[
  {
    "id": "dev_field",
    "name": "Hearthmoor",
    "size": 600,
    "spawn": {
      "x": 0,
      "z": 0
    },
    "spawnRadius": 7,
    "playerCap": 200,
    "terrain": {
      "seed": 1337,
      "amplitude": 7,
      "scale": 60,
      "flatRadius": 70,
      "farBoost": 2.2,
      "edgeStart": 245,
      "edgeHeight": 30
    },
    "mobSpawns": [
      {
        "mob": "training_dummy",
        "x": 35.9,
        "z": -28.4,
        "count": 1,
        "radius": 0
      },
      {
        "mob": "training_dummy",
        "x": 39.2,
        "z": -30.7,
        "count": 1,
        "radius": 0
      },
      {
        "mob": "training_dummy",
        "x": 33.6,
        "z": -34.3,
        "count": 1,
        "radius": 0
      },
      {
        "mob": "bristle_boar",
        "x": 24,
        "z": 82,
        "count": 8,
        "radius": 11
      },
      {
        "mob": "bristle_boar",
        "x": 70,
        "z": -12,
        "count": 8,
        "radius": 10
      },
      {
        "mob": "bristle_boar",
        "x": -18,
        "z": -74,
        "count": 8,
        "radius": 11
      },
      {
        "mob": "bristle_boar",
        "x": -78,
        "z": 26,
        "count": 8,
        "radius": 11
      },
      {
        "mob": "bristle_boar",
        "x": 70,
        "z": 45,
        "count": 12,
        "radius": 14
      },
      {
        "mob": "bristle_boar",
        "x": 28,
        "z": 120,
        "count": 12,
        "radius": 17
      },
      {
        "mob": "bristle_boar",
        "x": 138,
        "z": -58,
        "count": 12,
        "radius": 17
      },
      {
        "mob": "bristle_boar",
        "x": -74,
        "z": -56,
        "count": 10,
        "radius": 14
      },
      {
        "mob": "ash_wolf",
        "x": -118,
        "z": 98,
        "count": 12,
        "radius": 19
      },
      {
        "mob": "ash_wolf",
        "x": -172,
        "z": 138,
        "count": 12,
        "radius": 19
      },
      {
        "mob": "ash_wolf",
        "x": -80,
        "z": 170,
        "count": 10,
        "radius": 17
      },
      {
        "mob": "mire_toad",
        "x": -92,
        "z": -118,
        "count": 10,
        "radius": 14
      },
      {
        "mob": "mire_toad",
        "x": -165,
        "z": -172,
        "count": 10,
        "radius": 14
      },
      {
        "mob": "mire_toad",
        "x": -120,
        "z": -190,
        "count": 9,
        "radius": 13
      },
      {
        "mob": "stone_husk",
        "x": 60,
        "z": 218,
        "count": 6,
        "radius": 12
      },
      {
        "mob": "stone_husk",
        "x": 150,
        "z": -188,
        "count": 6,
        "radius": 14
      },
      {
        "mob": "stone_husk",
        "x": 195,
        "z": -130,
        "count": 4,
        "radius": 12
      },
      {
        "mob": "thornback_boar",
        "x": 170,
        "z": 15,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "thornback_boar",
        "x": -200,
        "z": -20,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "bandit",
        "x": -50,
        "z": -235,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "bandit",
        "x": 185,
        "z": 160,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "alpha_wolf",
        "x": -215,
        "z": 60,
        "count": 8,
        "radius": 14
      },
      {
        "mob": "mire_lurker",
        "x": -200,
        "z": -110,
        "count": 8,
        "radius": 12
      },
      {
        "mob": "barrow_skeleton",
        "x": -186,
        "z": 205,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "barrow_skeleton",
        "x": 40,
        "z": 240,
        "count": 8,
        "radius": 12
      },
      {
        "mob": "ash_wolf",
        "x": -130,
        "z": 60,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "ash_wolf",
        "x": 112,
        "z": -100,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "mire_toad",
        "x": -60,
        "z": -130,
        "count": 9,
        "radius": 13
      },
      {
        "mob": "ash_wolf",
        "x": 122,
        "z": 92,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "old_tusk",
        "x": 215,
        "z": 80,
        "count": 1,
        "radius": 3
      }
    ],
    "town": {
      "name": "Emberfold",
      "palette": "ashen",
      "plaza": {
        "x": 0,
        "z": 0,
        "radius": 25
      },
      "palisade": {
        "radius": 56.0,
        "gateAngles": [0, 90, 180, 270],
        "gateWidth": 7,
        "postSpacing": 0.6
      },
      "paths": [
        {
          "width": 3.4,
          "points": [[0.0, 25.3], [0.0, 56.0], [0, 90], [20, 150], [45, 198], [60, 215]]
        },
        {
          "width": 3.4,
          "points": [[25.3, 0.0], [56.0, 0.0], [95, 5], [140, 10], [200, 4]]
        },
        {
          "width": 3.4,
          "points": [
            [0.0, -25.3],
            [0.0, -56.0],
            [4, -100],
            [6, -150],
            [20, -198],
            [60, -230],
            [130, -200],
            [150, -185]
          ]
        },
        {
          "width": 3.4,
          "points": [[-25.3, 0.0], [-56.0, 0.0], [-95, 5], [-140, 30], [-170, 70]]
        },
        {
          "width": 2.6,
          "points": [[0, 90], [-60, 130], [-120, 168], [-185, 185]]
        },
        {
          "width": 2.6,
          "points": [[-95, 5], [-110, -60], [-104, -98]]
        },
        {
          "width": 2.6,
          "points": [[-95, 5], [-150, -5], [-190, -18]]
        },
        {
          "width": 2.6,
          "points": [[140, 10], [150, 80], [168, 142]]
        }
      ],
      "structures": [
        {
          "type": "sign_anvil",
          "x": 25.6,
          "z": -9.5,
          "rot": -69.6
        },
        {
          "type": "sign_scroll",
          "x": 13.6,
          "z": -22.5,
          "rot": -31.1
        },
        {
          "type": "sign_trade",
          "x": -13.6,
          "z": 22.5,
          "rot": 148.9
        },
        {
          "type": "fountain",
          "x": 0.0,
          "z": 0.0,
          "rot": 0
        },
        {
          "type": "banner",
          "x": -14.3,
          "z": -14.3,
          "rot": 45
        },
        {
          "type": "banner",
          "x": -14.3,
          "z": 14.3,
          "rot": 135
        },
        {
          "type": "banner",
          "x": 14.3,
          "z": -14.3,
          "rot": 135
        },
        {
          "type": "banner",
          "x": 14.3,
          "z": 14.3,
          "rot": 45
        },
        {
          "type": "bench",
          "x": -9.3,
          "z": 20.3,
          "rot": 180
        },
        {
          "type": "bench",
          "x": 9.3,
          "z": 20.3,
          "rot": 180
        },
        {
          "type": "bench",
          "x": -9.3,
          "z": -20.3,
          "rot": 0
        },
        {
          "type": "bench",
          "x": 9.3,
          "z": -20.3,
          "rot": 0
        },
        {
          "type": "bench",
          "x": 20.3,
          "z": 9.3,
          "rot": 270
        },
        {
          "type": "bench",
          "x": 20.3,
          "z": -9.3,
          "rot": 270
        },
        {
          "type": "bench",
          "x": -20.3,
          "z": 9.3,
          "rot": 90
        },
        {
          "type": "bench",
          "x": -20.3,
          "z": -9.3,
          "rot": 90
        },
        {
          "type": "market_stall",
          "x": -18.8,
          "z": 18.8,
          "rot": 135
        },
        {
          "type": "market_stall",
          "x": 18.8,
          "z": -18.8,
          "rot": 315
        },
        {
          "type": "market_stall",
          "x": -18.8,
          "z": -18.8,
          "rot": 45
        },
        {
          "type": "planter",
          "x": 10.9,
          "z": 26.7,
          "rot": 0
        },
        {
          "type": "planter",
          "x": -10.9,
          "z": 26.7,
          "rot": 0
        },
        {
          "type": "planter",
          "x": 10.9,
          "z": -26.7,
          "rot": 0
        },
        {
          "type": "planter",
          "x": -10.9,
          "z": -26.7,
          "rot": 0
        },
        {
          "type": "planter",
          "x": 26.7,
          "z": 10.9,
          "rot": 0
        },
        {
          "type": "planter",
          "x": 26.7,
          "z": -10.9,
          "rot": 0
        },
        {
          "type": "planter",
          "x": -26.7,
          "z": 10.9,
          "rot": 0
        },
        {
          "type": "planter",
          "x": -26.7,
          "z": -10.9,
          "rot": 0
        },
        {
          "type": "tavern",
          "x": -21.1,
          "z": 33.9,
          "rot": 180
        },
        {
          "type": "barrel",
          "x": -10.0,
          "z": 30.9,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": -9.3,
          "z": 32.4,
          "rot": 0
        },
        {
          "type": "crate",
          "x": -32.1,
          "z": 27.5,
          "rot": 0
        },
        {
          "type": "house_tall",
          "x": -33.9,
          "z": 38.1,
          "rot": 135
        },
        {
          "type": "house_small",
          "x": -42.8,
          "z": 19.2,
          "rot": 110
        },
        {
          "type": "garden",
          "x": -21.1,
          "z": 46.5,
          "rot": 0
        },
        {
          "type": "woodpile",
          "x": -43.2,
          "z": 29.2,
          "rot": 110
        },
        {
          "type": "notice_board",
          "x": -9.2,
          "z": 26.9,
          "rot": 180
        },
        {
          "type": "house_large",
          "x": 21.1,
          "z": 33.9,
          "rot": 180
        },
        {
          "type": "house_tall",
          "x": 35.3,
          "z": 36.7,
          "rot": 225
        },
        {
          "type": "house_small",
          "x": 43.1,
          "z": 17.9,
          "rot": 200
        },
        {
          "type": "woodpile",
          "x": 28.0,
          "z": 43.3,
          "rot": 200
        },
        {
          "type": "cart",
          "x": 9.9,
          "z": 43.9,
          "rot": 15
        },
        {
          "type": "garden",
          "x": 19.7,
          "z": 46.7,
          "rot": 0
        },
        {
          "type": "smithy",
          "x": 28.3,
          "z": -19.5,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": 36.0,
          "z": -10.9,
          "rot": 0
        },
        {
          "type": "crate",
          "x": 23.1,
          "z": -13.1,
          "rot": 0
        },
        {
          "type": "crate",
          "x": 22.9,
          "z": -15.2,
          "rot": 20
        },
        {
          "type": "house_large",
          "x": 19.6,
          "z": -40.7,
          "rot": 0
        },
        {
          "type": "house_small",
          "x": 42.8,
          "z": -19.2,
          "rot": 340
        },
        {
          "type": "archery_target",
          "x": 39.3,
          "z": -37.9,
          "rot": 40
        },
        {
          "type": "woodpile",
          "x": 9.7,
          "z": -44.8,
          "rot": 0
        },
        {
          "type": "chapel",
          "x": -22.4,
          "z": -33.7,
          "rot": 0
        },
        {
          "type": "statue",
          "x": -25.3,
          "z": -20.8,
          "rot": 0
        },
        {
          "type": "house_small",
          "x": -41.6,
          "z": -20.8,
          "rot": 70
        },
        {
          "type": "house_tall",
          "x": -32.7,
          "z": -36.5,
          "rot": 45
        },
        {
          "type": "garden",
          "x": -6.5,
          "z": -47.9,
          "rot": 90
        },
        {
          "type": "crate",
          "x": 13.9,
          "z": -23.7,
          "rot": 10
        },
        {
          "type": "barrel",
          "x": -24.1,
          "z": -13.5,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": 23.6,
          "z": 14.0,
          "rot": 0
        },
        {
          "type": "crate",
          "x": -23.7,
          "z": 13.3,
          "rot": 30
        },
        {
          "type": "planter",
          "x": 5.3,
          "z": -36.9,
          "rot": 0
        },
        {
          "type": "planter",
          "x": -36.9,
          "z": -5.3,
          "rot": 0
        },
        {
          "type": "planter",
          "x": 36.9,
          "z": 5.3,
          "rot": 0
        },
        {
          "type": "planter",
          "x": 4.7,
          "z": 47.1,
          "rot": 0
        },
        {
          "type": "planter",
          "x": -5.3,
          "z": 36.9,
          "rot": 0
        },
        {
          "type": "tree_birch",
          "x": -13.7,
          "z": 51.1,
          "rot": 0
        },
        {
          "type": "tree_birch",
          "x": 26.7,
          "z": -49.3,
          "rot": 0
        },
        {
          "type": "tree_oak",
          "x": -49.5,
          "z": -19.2,
          "rot": 0
        },
        {
          "type": "garden",
          "x": -38.4,
          "z": -12.8,
          "rot": 90
        },
        {
          "type": "well",
          "x": 12.0,
          "z": -34.1,
          "rot": 0
        },
        {
          "type": "house_small",
          "x": 34.7,
          "z": 16.5,
          "rot": 180
        },
        {
          "type": "house_small",
          "x": -35.3,
          "z": 11.7,
          "rot": 90
        },
        {
          "type": "tower",
          "x": -48.8,
          "z": -8.7,
          "rot": 0
        },
        {
          "type": "tower",
          "x": 48.8,
          "z": 8.7,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 5.3,
          "z": 31.5,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -4.5,
          "z": 42.1,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 4.0,
          "z": 51.6,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 31.5,
          "z": 5.3,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 42.1,
          "z": -4.5,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 51.6,
          "z": 4.0,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -5.3,
          "z": -31.5,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 4.5,
          "z": -42.1,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -4.0,
          "z": -51.6,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -31.5,
          "z": -5.3,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -42.1,
          "z": 4.5,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -51.6,
          "z": -4.0,
          "rot": 0
        },
        {
          "type": "tree_oak",
          "x": -28.3,
          "z": 47.2,
          "rot": 0
        },
        {
          "type": "tree_oak",
          "x": 44.9,
          "z": 30.0,
          "rot": 0
        },
        {
          "type": "tree_oak",
          "x": -46.7,
          "z": 32.0,
          "rot": 0
        },
        {
          "type": "tree_oak",
          "x": 45.5,
          "z": -32.1,
          "rot": 0
        },
        {
          "type": "tree_pine",
          "x": -42.7,
          "z": -40.0,
          "rot": 0
        },
        {
          "type": "tree_oak",
          "x": 12.7,
          "z": -49.3,
          "rot": 0
        },
        {
          "type": "bridge",
          "x": 94.0,
          "z": 4.5,
          "rot": 90
        },
        {
          "type": "bridge",
          "x": 22.5,
          "z": -200.0,
          "rot": 129
        },
        {
          "type": "barn",
          "x": 186.0,
          "z": 36.0,
          "rot": 270
        },
        {
          "type": "house_small",
          "x": 150.0,
          "z": 44.0,
          "rot": 180
        },
        {
          "type": "house_small",
          "x": 212.0,
          "z": 28.0,
          "rot": 270
        },
        {
          "type": "windmill",
          "x": 205.0,
          "z": -22.0,
          "rot": 20
        },
        {
          "type": "field",
          "x": 140.0,
          "z": -18.0,
          "rot": 0
        },
        {
          "type": "field",
          "x": 156.0,
          "z": -18.0,
          "rot": 0
        },
        {
          "type": "field",
          "x": 172.0,
          "z": -18.0,
          "rot": 0
        },
        {
          "type": "field",
          "x": 188.0,
          "z": -18.0,
          "rot": 0
        },
        {
          "type": "field",
          "x": 140.0,
          "z": -30.0,
          "rot": 0
        },
        {
          "type": "field",
          "x": 156.0,
          "z": -30.0,
          "rot": 0
        },
        {
          "type": "field",
          "x": 172.0,
          "z": -30.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 134.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 138.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 142.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 146.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 150.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 154.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 158.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 162.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 166.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 170.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 174.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 178.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 182.0,
          "z": -37.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 134.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 138.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 142.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 146.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 150.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 154.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 158.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 162.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 166.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 170.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 174.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 178.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": 182.0,
          "z": -11.0,
          "rot": 0
        },
        {
          "type": "haystack",
          "x": 176.0,
          "z": 52.0,
          "rot": 0
        },
        {
          "type": "haystack",
          "x": 196.0,
          "z": 54.0,
          "rot": 0
        },
        {
          "type": "cart",
          "x": 162.0,
          "z": 34.0,
          "rot": 30
        },
        {
          "type": "barrel",
          "x": 154.0,
          "z": 38.0,
          "rot": 0
        },
        {
          "type": "crate",
          "x": 146.0,
          "z": 38.0,
          "rot": 0
        },
        {
          "type": "signpost",
          "x": 120.0,
          "z": 12.0,
          "rot": 90
        },
        {
          "type": "house_small",
          "x": -14.0,
          "z": -138.0,
          "rot": 90
        },
        {
          "type": "house_small",
          "x": -15.0,
          "z": -160.0,
          "rot": 90
        },
        {
          "type": "house_large",
          "x": 24.0,
          "z": -140.0,
          "rot": 270
        },
        {
          "type": "well",
          "x": -6.0,
          "z": -122.0,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 9.0,
          "z": -130.0,
          "rot": 0
        },
        {
          "type": "field",
          "x": -30.0,
          "z": -182.0,
          "rot": 0
        },
        {
          "type": "haystack",
          "x": -22.0,
          "z": -172.0,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": -9.0,
          "z": -146.0,
          "rot": 0
        },
        {
          "type": "crate",
          "x": -9.0,
          "z": -149.0,
          "rot": 0
        },
        {
          "type": "signpost",
          "x": 8.0,
          "z": -108.0,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": 60.0,
          "z": 206.0,
          "rot": -15
        },
        {
          "type": "ruin_wall",
          "x": 46.0,
          "z": 214.0,
          "rot": 75
        },
        {
          "type": "ruin_wall",
          "x": 74.0,
          "z": 222.0,
          "rot": 105
        },
        {
          "type": "ruin_wall",
          "x": 58.0,
          "z": 232.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 50.0,
          "z": 226.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 68.0,
          "z": 230.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 44.0,
          "z": 204.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 77.0,
          "z": 208.0,
          "rot": 0
        },
        {
          "type": "crypt",
          "x": -186.0,
          "z": 226.0,
          "rot": 180
        },
        {
          "type": "ruin_arch",
          "x": -186.0,
          "z": 178.0,
          "rot": 0
        },
        {
          "type": "signpost",
          "x": -150.0,
          "z": 172.0,
          "rot": 300
        },
        {
          "type": "fence",
          "x": -206.0,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -201.5,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -197.0,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -192.5,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -188.0,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -183.5,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -179.0,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -174.5,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -170.0,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "fence",
          "x": -165.5,
          "z": 174.0,
          "rot": 0
        },
        {
          "type": "standing_stone",
          "x": -205.0,
          "z": -13.0,
          "rot": 0.0
        },
        {
          "type": "standing_stone",
          "x": -199.2,
          "z": -15.1,
          "rot": 40.0
        },
        {
          "type": "standing_stone",
          "x": -196.1,
          "z": -20.4,
          "rot": 80.0
        },
        {
          "type": "standing_stone",
          "x": -197.2,
          "z": -26.5,
          "rot": 120.0
        },
        {
          "type": "standing_stone",
          "x": -201.9,
          "z": -30.5,
          "rot": 160.0
        },
        {
          "type": "standing_stone",
          "x": -208.1,
          "z": -30.5,
          "rot": 200.0
        },
        {
          "type": "standing_stone",
          "x": -212.8,
          "z": -26.5,
          "rot": 240.0
        },
        {
          "type": "standing_stone",
          "x": -213.9,
          "z": -20.4,
          "rot": 280.0
        },
        {
          "type": "standing_stone",
          "x": -210.8,
          "z": -15.1,
          "rot": 320.0
        },
        {
          "type": "tent",
          "x": 163.0,
          "z": 150.0,
          "rot": 40
        },
        {
          "type": "tent",
          "x": 178.0,
          "z": 145.0,
          "rot": 320
        },
        {
          "type": "tent",
          "x": 170.0,
          "z": 162.0,
          "rot": 180
        },
        {
          "type": "campfire",
          "x": 171.0,
          "z": 152.0,
          "rot": 0
        },
        {
          "type": "log",
          "x": 166.0,
          "z": 155.0,
          "rot": 90
        },
        {
          "type": "log",
          "x": 176.0,
          "z": 155.0,
          "rot": 20
        },
        {
          "type": "crate",
          "x": 160.0,
          "z": 144.0,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": 161.0,
          "z": 146.0,
          "rot": 0
        },
        {
          "type": "signpost",
          "x": 4.0,
          "z": 95.0,
          "rot": 0
        },
        {
          "type": "signpost",
          "x": -92.0,
          "z": 9.0,
          "rot": 270
        },
        {
          "type": "victory_banner",
          "x": 9,
          "z": 44,
          "rot": 270
        }
      ],
      "greenery": 4
    },
    "world": {
      "seed": 90210,
      "water": {
        "level": -0.35,
        "depth": 1.0,
        "rivers": [
          {
            "width": 12,
            "points": [
              [150, 300],
              [130, 220],
              [105, 150],
              [88, 80],
              [95, 20],
              [92, -40],
              [70, -110],
              [40, -170],
              [5, -230],
              [-30, -300]
            ]
          }
        ],
        "lakes": [
          {
            "x": -130,
            "z": -140,
            "r": 34
          }
        ]
      },
      "regions": [
        {
          "biome": "forest",
          "x": 0,
          "z": 0,
          "r": 320,
          "density": 0.55,
          "name": "Emberwood"
        },
        {
          "biome": "meadow",
          "x": 0,
          "z": 0,
          "r": 105,
          "density": 1.1,
          "name": "Emberfold Fields"
        },
        {
          "biome": "forest",
          "x": 62,
          "z": -62,
          "r": 24,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": -64,
          "z": 58,
          "r": 26,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": -58,
          "z": -66,
          "r": 22,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": 66,
          "z": 64,
          "r": 22,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": -92,
          "z": -8,
          "r": 20,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": 92,
          "z": -24,
          "r": 18,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": 20,
          "z": -80,
          "r": 16,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": -24,
          "z": 84,
          "r": 18,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": 84,
          "z": 22,
          "r": 14,
          "density": 2.6
        },
        {
          "biome": "forest",
          "x": -30,
          "z": -92,
          "r": 16,
          "density": 2.6
        },
        {
          "biome": "meadow",
          "x": 25,
          "z": 120,
          "r": 45,
          "density": 1.4,
          "name": "Boar Meadow"
        },
        {
          "biome": "farmland",
          "x": 170,
          "z": 15,
          "r": 72,
          "density": 0.9,
          "name": "Hollow Farms"
        },
        {
          "biome": "forest",
          "x": 185,
          "z": 160,
          "r": 85,
          "density": 2.4,
          "name": "Oldwood"
        },
        {
          "biome": "pine_forest",
          "x": -140,
          "z": 115,
          "r": 95,
          "density": 2.8,
          "name": "Wolfpine Forest"
        },
        {
          "biome": "birch_grove",
          "x": -200,
          "z": -20,
          "r": 55,
          "density": 2.0,
          "name": "Silverbirch Grove"
        },
        {
          "biome": "marsh",
          "x": -130,
          "z": -145,
          "r": 78,
          "density": 2.4,
          "name": "Mirewater"
        },
        {
          "biome": "forest",
          "x": -50,
          "z": -235,
          "r": 70,
          "density": 2.5,
          "name": "Southwood"
        },
        {
          "biome": "meadow",
          "x": 0,
          "z": -150,
          "r": 40,
          "density": 1.2,
          "name": "Brookside Hamlet"
        },
        {
          "biome": "rocky",
          "x": 155,
          "z": -180,
          "r": 80,
          "density": 1.6,
          "name": "Cragfell Hills"
        },
        {
          "biome": "rocky",
          "x": 60,
          "z": 220,
          "r": 62,
          "density": 1.3,
          "name": "Fallen Keep Ruins"
        },
        {
          "biome": "graveyard",
          "x": -186,
          "z": 205,
          "r": 36,
          "density": 1.2,
          "name": "Old Graveyard"
        },
        {
          "name": "Old Tusk's Wallow",
          "biome": "meadow",
          "x": 215,
          "z": 80,
          "r": 20,
          "density": 0.3
        }
      ],
      "groundCover": 0.55,
      "clearings": [
        {
          "x": 70,
          "z": 45,
          "r": 16
        },
        {
          "x": 28,
          "z": 120,
          "r": 18
        },
        {
          "x": 138,
          "z": -58,
          "r": 18
        },
        {
          "x": -74,
          "z": -56,
          "r": 16
        },
        {
          "x": -118,
          "z": 98,
          "r": 20
        },
        {
          "x": -172,
          "z": 138,
          "r": 20
        },
        {
          "x": -80,
          "z": 170,
          "r": 18
        },
        {
          "x": -92,
          "z": -118,
          "r": 16
        },
        {
          "x": -165,
          "z": -172,
          "r": 16
        },
        {
          "x": -120,
          "z": -190,
          "r": 15
        },
        {
          "x": 60,
          "z": 218,
          "r": 16
        },
        {
          "x": 150,
          "z": -188,
          "r": 18
        },
        {
          "x": 195,
          "z": -130,
          "r": 16
        },
        {
          "x": 60,
          "z": 216,
          "r": 22
        },
        {
          "x": 170,
          "z": 152,
          "r": 16
        },
        {
          "x": -205,
          "z": -22,
          "r": 13
        },
        {
          "x": 2,
          "z": -150,
          "r": 24
        },
        {
          "x": 168,
          "z": 10,
          "r": 42
        },
        {
          "x": -186,
          "z": 226,
          "r": 8
        },
        {
          "x": -10.4,
          "z": 45.7,
          "r": 5
        },
        {
          "x": 170,
          "z": 15,
          "r": 16
        },
        {
          "x": -200,
          "z": -20,
          "r": 16
        },
        {
          "x": -50,
          "z": -235,
          "r": 16
        },
        {
          "x": 185,
          "z": 160,
          "r": 16
        },
        {
          "x": -215,
          "z": 60,
          "r": 16
        },
        {
          "x": -200,
          "z": -110,
          "r": 14
        },
        {
          "x": -186,
          "z": 205,
          "r": 16
        },
        {
          "x": 40,
          "z": 240,
          "r": 14
        },
        {
          "x": 24,
          "z": 82,
          "r": 15
        },
        {
          "x": 70,
          "z": -12,
          "r": 14
        },
        {
          "x": -18,
          "z": -74,
          "r": 15
        },
        {
          "x": -78,
          "z": 26,
          "r": 15
        },
        {
          "x": -130,
          "z": 60,
          "r": 18
        },
        {
          "x": 112,
          "z": -100,
          "r": 18
        },
        {
          "x": -60,
          "z": -130,
          "r": 17
        },
        {
          "x": 122,
          "z": 92,
          "r": 18
        },
        {
          "x": 215,
          "z": 80,
          "r": 16
        }
      ]
    },
    "portals": [
      {
        "x": -10.4,
        "z": 45.7,
        "rot": 90,
        "label": "Travel gate"
      }
    ]
  },
  {
    "id": "human_homeland",
    "name": "Valcrest",
    "nation": "human",
    "size": 400,
    "spawn": {
      "x": 0,
      "z": 0
    },
    "spawnRadius": 6,
    "playerCap": 200,
    "terrain": {
      "seed": 2024,
      "amplitude": 6,
      "scale": 55,
      "flatRadius": 52,
      "farBoost": 2,
      "edgeStart": 165,
      "edgeHeight": 26
    },
    "mobSpawns": [
      {
        "mob": "cave_bear",
        "x": 110,
        "z": 110,
        "count": 10,
        "radius": 17
      },
      {
        "mob": "cave_bear",
        "x": 60,
        "z": -70,
        "count": 9,
        "radius": 12
      },
      {
        "mob": "forest_troll",
        "x": -100,
        "z": 90,
        "count": 10,
        "radius": 17
      },
      {
        "mob": "granite_golem",
        "x": -95,
        "z": -100,
        "count": 8,
        "radius": 12
      },
      {
        "mob": "dire_wolf",
        "x": 95,
        "z": -110,
        "count": 10,
        "radius": 14
      },
      {
        "mob": "ogre_brute",
        "x": -140,
        "z": -20,
        "count": 8,
        "radius": 14
      },
      {
        "mob": "thornback_boar",
        "x": -45,
        "z": -62,
        "count": 9,
        "radius": 12
      },
      {
        "mob": "bandit",
        "x": -60,
        "z": 25,
        "count": 9,
        "radius": 12
      },
      {
        "mob": "alpha_wolf",
        "x": 30,
        "z": 80,
        "count": 9,
        "radius": 13
      },
      {
        "mob": "mire_lurker",
        "x": 80,
        "z": -40,
        "count": 8,
        "radius": 12
      },
      {
        "mob": "barrow_skeleton",
        "x": -35,
        "z": 100,
        "count": 8,
        "radius": 12
      },
      {
        "mob": "forest_troll",
        "x": 140,
        "z": 40,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "dire_wolf",
        "x": -150,
        "z": 50,
        "count": 8,
        "radius": 14
      },
      {
        "mob": "ogre_brute",
        "x": 40,
        "z": -160,
        "count": 6,
        "radius": 13
      },
      {
        "mob": "barrow_king",
        "x": -60,
        "z": 140,
        "count": 1,
        "radius": 3
      },
      {
        "mob": "mossback",
        "x": 135,
        "z": -45,
        "count": 1,
        "radius": 3
      }
    ],
    "town": {
      "name": "Valcrest",
      "palette": "verdant",
      "wall": "stone",
      "plaza": {
        "x": 0,
        "z": 0,
        "radius": 12
      },
      "palisade": {
        "radius": 42,
        "gateAngles": [90, 180, 270],
        "gateWidth": 7,
        "postSpacing": 0.6
      },
      "paths": [
        {
          "width": 3.4,
          "points": [[0, 10], [0, 19]]
        },
        {
          "width": 3.4,
          "points": [[10, 0], [42, 0], [110, 10], [160, -20]]
        },
        {
          "width": 3.4,
          "points": [[0, -10], [0, -42], [0, -62], [-20, -130], [-10, -170]]
        },
        {
          "width": 3.4,
          "points": [[-10, 0], [-42, 0], [-110, -10], [-160, 20]]
        }
      ],
      "structures": [
        {
          "type": "statue",
          "x": 0,
          "z": 0,
          "rot": 180
        },
        {
          "type": "planter",
          "x": 5,
          "z": 5,
          "rot": 0
        },
        {
          "type": "planter",
          "x": -5,
          "z": 5,
          "rot": 0
        },
        {
          "type": "planter",
          "x": 5,
          "z": -5,
          "rot": 0
        },
        {
          "type": "planter",
          "x": -5,
          "z": -5,
          "rot": 0
        },
        {
          "type": "bench",
          "x": -3.8,
          "z": 8.3,
          "rot": 180
        },
        {
          "type": "bench",
          "x": 3.8,
          "z": -8.3,
          "rot": 0
        },
        {
          "type": "bench",
          "x": 8.3,
          "z": -3.8,
          "rot": 270
        },
        {
          "type": "bench",
          "x": -8.3,
          "z": 3.8,
          "rot": 90
        },
        {
          "type": "banner",
          "x": 7.6,
          "z": 7.6,
          "rot": 45
        },
        {
          "type": "banner",
          "x": -7.6,
          "z": -7.6,
          "rot": 225
        },
        {
          "type": "banner",
          "x": -7.6,
          "z": 7.6,
          "rot": 135
        },
        {
          "type": "banner",
          "x": 7.6,
          "z": -7.6,
          "rot": 315
        },
        {
          "type": "keep",
          "x": 0,
          "z": 26,
          "rot": 180
        },
        {
          "type": "lamp",
          "x": -3,
          "z": 17,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 3,
          "z": 17,
          "rot": 0
        },
        {
          "type": "cathedral",
          "x": 24,
          "z": 20,
          "rot": 270
        },
        {
          "type": "hedge",
          "x": 13,
          "z": 31,
          "rot": 0
        },
        {
          "type": "hedge",
          "x": 17,
          "z": 31,
          "rot": 0
        },
        {
          "type": "hedge",
          "x": 13,
          "z": 12.5,
          "rot": 0
        },
        {
          "type": "planter",
          "x": 12,
          "z": 16,
          "rot": 0
        },
        {
          "type": "planter",
          "x": 12,
          "z": 24,
          "rot": 0
        },
        {
          "type": "barracks",
          "x": -22,
          "z": 20,
          "rot": 90
        },
        {
          "type": "training_dummy",
          "x": -12,
          "z": 24,
          "rot": 0
        },
        {
          "type": "training_dummy",
          "x": -12,
          "z": 29,
          "rot": 0
        },
        {
          "type": "training_dummy",
          "x": -9,
          "z": 33,
          "rot": 0
        },
        {
          "type": "archery_target",
          "x": -14,
          "z": 35,
          "rot": 160
        },
        {
          "type": "woodpile",
          "x": -28,
          "z": 32,
          "rot": 90
        },
        {
          "type": "market_stall",
          "x": 22,
          "z": 5.5,
          "rot": 180
        },
        {
          "type": "market_stall",
          "x": 28,
          "z": 5.5,
          "rot": 180
        },
        {
          "type": "market_stall",
          "x": 16,
          "z": -5.5,
          "rot": 0
        },
        {
          "type": "market_stall",
          "x": 22,
          "z": -5.5,
          "rot": 0
        },
        {
          "type": "sign_trade",
          "x": 25,
          "z": 3.5,
          "rot": 270
        },
        {
          "type": "crate",
          "x": 31,
          "z": -5,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": 31,
          "z": -6.4,
          "rot": 0
        },
        {
          "type": "cart",
          "x": 33,
          "z": 6,
          "rot": 90
        },
        {
          "type": "house_tall",
          "x": 8.5,
          "z": -16,
          "rot": 270
        },
        {
          "type": "house_tall",
          "x": -8.5,
          "z": -16,
          "rot": 90
        },
        {
          "type": "house_tall",
          "x": 8.5,
          "z": -23,
          "rot": 270
        },
        {
          "type": "house_tall",
          "x": -8.5,
          "z": -23,
          "rot": 90
        },
        {
          "type": "house_tall",
          "x": 8.5,
          "z": -30,
          "rot": 270
        },
        {
          "type": "house_tall",
          "x": -8.5,
          "z": -30,
          "rot": 90
        },
        {
          "type": "house_large",
          "x": 21,
          "z": -20,
          "rot": 0
        },
        {
          "type": "house_small",
          "x": 28,
          "z": -29,
          "rot": 315
        },
        {
          "type": "well",
          "x": -19,
          "z": -10,
          "rot": 0
        },
        {
          "type": "garden",
          "x": -22,
          "z": -22,
          "rot": 90
        },
        {
          "type": "garden",
          "x": -22,
          "z": -30,
          "rot": 90
        },
        {
          "type": "smithy",
          "x": -28,
          "z": -6,
          "rot": 90
        },
        {
          "type": "house_small",
          "x": -17,
          "z": 8.5,
          "rot": 180
        },
        {
          "type": "house_small",
          "x": -26,
          "z": 8.5,
          "rot": 180
        },
        {
          "type": "tower",
          "x": 32,
          "z": -26,
          "rot": 0
        },
        {
          "type": "tower",
          "x": -33,
          "z": -24,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 2.9,
          "z": -17,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -2.9,
          "z": -27,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 2.9,
          "z": -37,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 17,
          "z": 2.9,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 27,
          "z": -2.9,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": 37,
          "z": 2.9,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -17,
          "z": -2.9,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -27,
          "z": 2.9,
          "rot": 0
        },
        {
          "type": "lamp",
          "x": -37,
          "z": -2.9,
          "rot": 0
        },
        {
          "type": "tree_oak",
          "x": 34,
          "z": 24,
          "rot": 0
        },
        {
          "type": "tree_birch",
          "x": -35,
          "z": 12,
          "rot": 0
        },
        {
          "type": "tree_oak",
          "x": 20,
          "z": -36,
          "rot": 0
        },
        {
          "type": "tree_birch",
          "x": -12,
          "z": -38,
          "rot": 0
        },
        {
          "type": "tree_birch",
          "x": 36,
          "z": -12,
          "rot": 0
        },
        {
          "type": "windmill",
          "x": 70,
          "z": 40,
          "rot": 15
        },
        {
          "type": "barn",
          "x": 90,
          "z": 62,
          "rot": 250
        },
        {
          "type": "field",
          "x": 60,
          "z": 20,
          "rot": 0
        },
        {
          "type": "field",
          "x": 76,
          "z": 20,
          "rot": 0
        },
        {
          "type": "field",
          "x": 60,
          "z": 8,
          "rot": 0
        },
        {
          "type": "house_small",
          "x": -70,
          "z": 50,
          "rot": 120
        },
        {
          "type": "house_small",
          "x": -80,
          "z": 62,
          "rot": 140
        },
        {
          "type": "well",
          "x": -66,
          "z": 64,
          "rot": 0
        },
        {
          "type": "tower",
          "x": 60,
          "z": -70,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -90,
          "z": -90,
          "rot": 30
        },
        {
          "type": "ruin_pillar",
          "x": -84,
          "z": -98,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": -96,
          "z": -84,
          "rot": 40
        },
        {
          "type": "signpost",
          "x": 6,
          "z": 64,
          "rot": 0
        },
        {
          "type": "market_stall",
          "x": 16,
          "z": 5.5,
          "rot": 180
        },
        {
          "type": "sign_scroll",
          "x": 13,
          "z": 3.5,
          "rot": 270
        }
      ]
    },
    "world": {
      "seed": 7001,
      "water": {
        "level": -0.35,
        "depth": 1.0,
        "rivers": [],
        "lakes": [
          {
            "x": 110,
            "z": -120,
            "r": 26
          }
        ]
      },
      "regions": [
        {
          "biome": "forest",
          "x": 0,
          "z": 0,
          "r": 220,
          "density": 0.7,
          "name": "Valcrest Vale"
        },
        {
          "biome": "meadow",
          "x": 0,
          "z": 0,
          "r": 95,
          "density": 1.1,
          "name": "Crown Fields"
        },
        {
          "biome": "farmland",
          "x": 72,
          "z": 35,
          "r": 42,
          "density": 0.9,
          "name": "King's Acres"
        },
        {
          "biome": "birch_grove",
          "x": -100,
          "z": 90,
          "r": 55,
          "density": 2.2,
          "name": "Whitebark Grove"
        },
        {
          "biome": "forest",
          "x": 110,
          "z": 110,
          "r": 55,
          "density": 2.4,
          "name": "Stagwood"
        },
        {
          "biome": "marsh",
          "x": 110,
          "z": -120,
          "r": 50,
          "density": 2.2,
          "name": "Reedmere"
        },
        {
          "biome": "rocky",
          "x": -110,
          "z": -80,
          "r": 60,
          "density": 1.5,
          "name": "Greystone Rise"
        },
        {
          "name": "The Barrow Throne",
          "biome": "graveyard",
          "x": -60,
          "z": 140,
          "r": 20,
          "density": 0.3
        },
        {
          "name": "Mossback Hollow",
          "biome": "pine_forest",
          "x": 135,
          "z": -45,
          "r": 20,
          "density": 0.3
        }
      ],
      "groundCover": 0.5,
      "clearings": [
        {
          "x": -100,
          "z": 90,
          "r": 20
        },
        {
          "x": 110,
          "z": 110,
          "r": 20
        },
        {
          "x": 95,
          "z": -110,
          "r": 16
        },
        {
          "x": -95,
          "z": -100,
          "r": 16
        },
        {
          "x": -140,
          "z": -20,
          "r": 18
        },
        {
          "x": 0,
          "z": -56,
          "r": 6
        },
        {
          "x": 70,
          "z": 40,
          "r": 26
        },
        {
          "x": -72,
          "z": 56,
          "r": 14
        },
        {
          "x": 60,
          "z": -70,
          "r": 6
        },
        {
          "x": -90,
          "z": -92,
          "r": 14
        },
        {
          "x": 14,
          "z": -60,
          "r": 6
        },
        {
          "x": -45,
          "z": -62,
          "r": 16
        },
        {
          "x": -60,
          "z": 25,
          "r": 16
        },
        {
          "x": 30,
          "z": 80,
          "r": 17
        },
        {
          "x": 80,
          "z": -40,
          "r": 16
        },
        {
          "x": -35,
          "z": 100,
          "r": 16
        },
        {
          "x": 140,
          "z": 40,
          "r": 18
        },
        {
          "x": -150,
          "z": 50,
          "r": 18
        },
        {
          "x": 40,
          "z": -160,
          "r": 17
        },
        {
          "x": -60,
          "z": 140,
          "r": 16
        },
        {
          "x": 135,
          "z": -45,
          "r": 16
        }
      ]
    },
    "portals": [
      {
        "x": 0,
        "z": -56,
        "rot": 0,
        "label": "Travel gate"
      }
    ],
    "minLevel": 10,
    "roamingBosses": {
      "mobs": ["gnarlhide", "redmane", "grimtusk", "bonecaller"],
      "everyMs": [900000, 1800000],
      "lifetimeMs": 1200000,
      "levelWindow": 6
    }
  },
  {
    "id": "orc_homeland",
    "name": "Gorzhak",
    "nation": "orc",
    "size": 400,
    "spawn": {
      "x": 0,
      "z": -4
    },
    "spawnRadius": 5,
    "playerCap": 200,
    "terrain": {
      "seed": 6666,
      "amplitude": 8,
      "scale": 45,
      "flatRadius": 50,
      "farBoost": 2.4,
      "edgeStart": 160,
      "edgeHeight": 32
    },
    "mobSpawns": [
      {
        "mob": "cave_bear",
        "x": 90,
        "z": 40,
        "count": 10,
        "radius": 14
      },
      {
        "mob": "cave_bear",
        "x": -60,
        "z": 60,
        "count": 9,
        "radius": 12
      },
      {
        "mob": "forest_troll",
        "x": -110,
        "z": 100,
        "count": 10,
        "radius": 17
      },
      {
        "mob": "dire_wolf",
        "x": 110,
        "z": -100,
        "count": 10,
        "radius": 17
      },
      {
        "mob": "granite_golem",
        "x": -120,
        "z": -110,
        "count": 8,
        "radius": 14
      },
      {
        "mob": "ogre_brute",
        "x": 130,
        "z": 120,
        "count": 8,
        "radius": 14
      },
      {
        "mob": "thornback_boar",
        "x": 40,
        "z": -60,
        "count": 9,
        "radius": 12
      },
      {
        "mob": "bandit",
        "x": -60,
        "z": 25,
        "count": 9,
        "radius": 12
      },
      {
        "mob": "alpha_wolf",
        "x": -30,
        "z": -80,
        "count": 9,
        "radius": 13
      },
      {
        "mob": "mire_lurker",
        "x": 70,
        "z": -40,
        "count": 8,
        "radius": 12
      },
      {
        "mob": "barrow_skeleton",
        "x": 40,
        "z": 85,
        "count": 8,
        "radius": 12
      },
      {
        "mob": "forest_troll",
        "x": -140,
        "z": 60,
        "count": 9,
        "radius": 14
      },
      {
        "mob": "dire_wolf",
        "x": 150,
        "z": 40,
        "count": 8,
        "radius": 14
      },
      {
        "mob": "ogre_brute",
        "x": -40,
        "z": -160,
        "count": 6,
        "radius": 13
      },
      {
        "mob": "barrow_king",
        "x": 70,
        "z": -135,
        "count": 1,
        "radius": 3
      },
      {
        "mob": "mossback",
        "x": -140,
        "z": -40,
        "count": 1,
        "radius": 3
      }
    ],
    "town": {
      "name": "Gorzhak",
      "palette": "grim",
      "wall": "stakes",
      "plaza": {
        "x": 0,
        "z": 0,
        "radius": 10
      },
      "palisade": {
        "radius": 42,
        "gateAngles": [0, 90, 180, 270],
        "gateWidth": 7,
        "postSpacing": 0.6
      },
      "paths": [
        {
          "width": 3.4,
          "points": [[0, 10], [0, 42], [0, 110], [25, 160]]
        },
        {
          "width": 3.4,
          "points": [[10, 0], [42, 0], [110, 10], [160, -20]]
        },
        {
          "width": 3.4,
          "points": [[0, -10], [0, -42], [0, -62], [-20, -130], [-10, -170]]
        },
        {
          "width": 3.4,
          "points": [[-10, 0], [-42, 0], [-110, -10], [-160, 20]]
        }
      ],
      "structures": [
        {
          "type": "bonfire",
          "x": 0,
          "z": 0,
          "rot": 0
        },
        {
          "type": "totem",
          "x": 0.0,
          "z": 7.5,
          "rot": 180.0
        },
        {
          "type": "totem",
          "x": 6.5,
          "z": 3.8,
          "rot": 240.0
        },
        {
          "type": "totem",
          "x": 6.5,
          "z": -3.7,
          "rot": 300.0
        },
        {
          "type": "totem",
          "x": 0.0,
          "z": -7.5,
          "rot": 360.0
        },
        {
          "type": "totem",
          "x": -6.5,
          "z": -3.8,
          "rot": 420.0
        },
        {
          "type": "totem",
          "x": -6.5,
          "z": 3.8,
          "rot": 480.0
        },
        {
          "type": "longhouse",
          "x": 0,
          "z": 24,
          "rot": 180
        },
        {
          "type": "orc_hut",
          "x": -24,
          "z": 14,
          "rot": 120
        },
        {
          "type": "orc_hut",
          "x": 24,
          "z": 14,
          "rot": 240
        },
        {
          "type": "orc_hut",
          "x": -26,
          "z": -12,
          "rot": 60
        },
        {
          "type": "orc_hut",
          "x": 26,
          "z": -12,
          "rot": 300
        },
        {
          "type": "orc_hut",
          "x": -14,
          "z": -26,
          "rot": 20
        },
        {
          "type": "orc_hut",
          "x": 14,
          "z": -26,
          "rot": 340
        },
        {
          "type": "orc_hut",
          "x": -30,
          "z": 26,
          "rot": 140
        },
        {
          "type": "orc_hut",
          "x": 30,
          "z": 26,
          "rot": 220
        },
        {
          "type": "smithy",
          "x": 18,
          "z": -6,
          "rot": 270
        },
        {
          "type": "market_stall",
          "x": -9,
          "z": 9,
          "rot": 135
        },
        {
          "type": "sign_trade",
          "x": -6.4,
          "z": 10.6,
          "rot": 148.9
        },
        {
          "type": "bonfire",
          "x": -17,
          "z": 4,
          "rot": 0
        },
        {
          "type": "bonfire",
          "x": 17,
          "z": 4,
          "rot": 0
        },
        {
          "type": "training_dummy",
          "x": -6,
          "z": -17,
          "rot": 0
        },
        {
          "type": "training_dummy",
          "x": 6,
          "z": -17,
          "rot": 0
        },
        {
          "type": "training_dummy",
          "x": -3,
          "z": -34,
          "rot": 0
        },
        {
          "type": "archery_target",
          "x": 10,
          "z": -34,
          "rot": 340
        },
        {
          "type": "woodpile",
          "x": -34,
          "z": -2,
          "rot": 90
        },
        {
          "type": "woodpile",
          "x": 34,
          "z": -2,
          "rot": 270
        },
        {
          "type": "woodpile",
          "x": -20,
          "z": -34,
          "rot": 30
        },
        {
          "type": "woodpile",
          "x": 20,
          "z": 34,
          "rot": 200
        },
        {
          "type": "banner",
          "x": -3.2,
          "z": 16,
          "rot": 0
        },
        {
          "type": "banner",
          "x": 3.2,
          "z": -40,
          "rot": 0
        },
        {
          "type": "banner",
          "x": 38,
          "z": 6,
          "rot": 0
        },
        {
          "type": "tent",
          "x": -36,
          "z": 10,
          "rot": 80
        },
        {
          "type": "tent",
          "x": 36,
          "z": 14,
          "rot": 280
        },
        {
          "type": "haystack",
          "x": -10,
          "z": 36,
          "rot": 0
        },
        {
          "type": "cart",
          "x": 12,
          "z": 37,
          "rot": 10
        },
        {
          "type": "barrel",
          "x": 8,
          "z": -10,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": -8,
          "z": -10,
          "rot": 0
        },
        {
          "type": "crate",
          "x": 21,
          "z": -15,
          "rot": 0
        },
        {
          "type": "standing_stone",
          "x": 80,
          "z": 60,
          "rot": 0
        },
        {
          "type": "standing_stone",
          "x": 86,
          "z": 66,
          "rot": 40
        },
        {
          "type": "standing_stone",
          "x": 74,
          "z": 68,
          "rot": 80
        },
        {
          "type": "ruin_wall",
          "x": -90,
          "z": 70,
          "rot": 20
        },
        {
          "type": "tent",
          "x": -70,
          "z": -60,
          "rot": 30
        },
        {
          "type": "tent",
          "x": -60,
          "z": -72,
          "rot": 120
        },
        {
          "type": "campfire",
          "x": -64,
          "z": -62,
          "rot": 0
        },
        {
          "type": "totem",
          "x": 60,
          "z": -80,
          "rot": 0
        },
        {
          "type": "totem",
          "x": -40,
          "z": 90,
          "rot": 180
        },
        {
          "type": "brazier",
          "x": 4,
          "z": 14,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -4,
          "z": 14,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 14,
          "z": 4,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 14,
          "z": -4,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -14,
          "z": 4,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -14,
          "z": -4,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 4,
          "z": -14,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -4,
          "z": -14,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 3.5,
          "z": 30,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -3.5,
          "z": 30,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 30,
          "z": 3.5,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 30,
          "z": -3.5,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -30,
          "z": 3.5,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -30,
          "z": -3.5,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 3.5,
          "z": -30,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -3.5,
          "z": -30,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 5,
          "z": 46,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -5,
          "z": 46,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 46,
          "z": 5,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 46,
          "z": -5,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -46,
          "z": 5,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -46,
          "z": -5,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 5,
          "z": -46,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -5,
          "z": -46,
          "rot": 0
        },
        {
          "type": "spikes",
          "x": 21.5,
          "z": 41.8,
          "rot": 117.2
        },
        {
          "type": "spikes",
          "x": 33.3,
          "z": 33.1,
          "rot": 135.2
        },
        {
          "type": "spikes",
          "x": 41.9,
          "z": 21.2,
          "rot": 153.2
        },
        {
          "type": "spikes",
          "x": 41.8,
          "z": -21.5,
          "rot": 207.2
        },
        {
          "type": "spikes",
          "x": 33.1,
          "z": -33.3,
          "rot": 225.2
        },
        {
          "type": "spikes",
          "x": 21.2,
          "z": -41.9,
          "rot": 243.2
        },
        {
          "type": "spikes",
          "x": -21.5,
          "z": -41.8,
          "rot": 297.2
        },
        {
          "type": "spikes",
          "x": -33.3,
          "z": -33.1,
          "rot": 315.2
        },
        {
          "type": "spikes",
          "x": -41.9,
          "z": -21.2,
          "rot": 333.2
        },
        {
          "type": "spikes",
          "x": -41.8,
          "z": 21.5,
          "rot": 387.2
        },
        {
          "type": "spikes",
          "x": -33.1,
          "z": 33.3,
          "rot": 405.2
        },
        {
          "type": "spikes",
          "x": -21.2,
          "z": 41.9,
          "rot": 423.2
        },
        {
          "type": "bone_pile",
          "x": -20,
          "z": -20,
          "rot": 0
        },
        {
          "type": "bone_pile",
          "x": 22,
          "z": -22,
          "rot": 0
        },
        {
          "type": "bone_pile",
          "x": -33,
          "z": 16,
          "rot": 0
        },
        {
          "type": "bone_pile",
          "x": 10,
          "z": 28,
          "rot": 0
        },
        {
          "type": "bone_pile",
          "x": -10,
          "z": -38,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 18,
          "z": 18,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -18,
          "z": 18,
          "rot": 0
        },
        {
          "type": "market_stall",
          "x": 9,
          "z": -9,
          "rot": 315
        },
        {
          "type": "market_stall",
          "x": 9,
          "z": 9,
          "rot": 225
        },
        {
          "type": "sign_scroll",
          "x": 6.4,
          "z": 10.6,
          "rot": -148.9
        }
      ]
    },
    "world": {
      "seed": 7002,
      "water": {
        "level": -0.35,
        "depth": 1.0,
        "rivers": [
          {
            "width": 10,
            "points": [[200, -40], [140, -20], [100, -60], [60, -140], [40, -200]]
          }
        ],
        "lakes": []
      },
      "regions": [
        {
          "name": "Gorzhak Badlands",
          "biome": "ashland",
          "x": 0,
          "z": 0,
          "r": 220,
          "density": 0.9
        },
        {
          "name": "Gorzhak Steppe",
          "biome": "ashland",
          "x": 0,
          "z": 0,
          "r": 90,
          "density": 0.6
        },
        {
          "name": "Blackpine Woods",
          "biome": "pine_forest",
          "x": -110,
          "z": 100,
          "r": 70,
          "density": 2.4
        },
        {
          "name": "Shadowpine",
          "biome": "pine_forest",
          "x": 110,
          "z": -100,
          "r": 55,
          "density": 2.2
        },
        {
          "name": "Skullrock Crags",
          "biome": "rocky",
          "x": -120,
          "z": -110,
          "r": 60,
          "density": 2
        },
        {
          "name": "Bone Circle",
          "biome": "graveyard",
          "x": 80,
          "z": 62,
          "r": 22,
          "density": 0.6
        },
        {
          "name": "Thornwood",
          "biome": "ashland",
          "x": 130,
          "z": 120,
          "r": 55,
          "density": 1.6
        },
        {
          "name": "The Barrow Throne",
          "biome": "graveyard",
          "x": 70,
          "z": -135,
          "r": 20,
          "density": 0.3
        },
        {
          "name": "Mossback Hollow",
          "biome": "pine_forest",
          "x": -140,
          "z": -40,
          "r": 20,
          "density": 0.3
        }
      ],
      "groundCover": 0.4,
      "clearings": [
        {
          "x": 90,
          "z": 40,
          "r": 18
        },
        {
          "x": -110,
          "z": 100,
          "r": 20
        },
        {
          "x": 110,
          "z": -100,
          "r": 20
        },
        {
          "x": -120,
          "z": -110,
          "r": 18
        },
        {
          "x": 130,
          "z": 120,
          "r": 18
        },
        {
          "x": 0,
          "z": -56,
          "r": 6
        },
        {
          "x": 80,
          "z": 64,
          "r": 12
        },
        {
          "x": -64,
          "z": -64,
          "r": 14
        },
        {
          "x": 14,
          "z": -60,
          "r": 6
        },
        {
          "x": 40,
          "z": -60,
          "r": 16
        },
        {
          "x": -60,
          "z": 25,
          "r": 16
        },
        {
          "x": -30,
          "z": -80,
          "r": 17
        },
        {
          "x": 70,
          "z": -40,
          "r": 16
        },
        {
          "x": 40,
          "z": 85,
          "r": 16
        },
        {
          "x": -140,
          "z": 60,
          "r": 18
        },
        {
          "x": 150,
          "z": 40,
          "r": 18
        },
        {
          "x": -40,
          "z": -160,
          "r": 17
        },
        {
          "x": 70,
          "z": -135,
          "r": 16
        },
        {
          "x": -140,
          "z": -40,
          "r": 16
        }
      ]
    },
    "portals": [
      {
        "x": 0,
        "z": -56,
        "rot": 0,
        "label": "Travel gate"
      }
    ],
    "mood": "grim",
    "minLevel": 10,
    "roamingBosses": {
      "mobs": ["gnarlhide", "redmane", "grimtusk", "bonecaller"],
      "everyMs": [900000, 1800000],
      "lifetimeMs": 1200000,
      "levelWindow": 6
    }
  },
  {
    "id": "colony_zone",
    "name": "Colony Zone",
    "size": 800,
    "pvp": true,
    "spawn": {
      "x": 0,
      "z": 0
    },
    "spawnRadius": 4,
    "playerCap": 200,
    "bases": {
      "human": {
        "x": 0,
        "z": -300
      },
      "orc": {
        "x": 0,
        "z": 300
      },
      "safeRadius": 24,
      "guard": {
        "radius": 34,
        "everyMs": 1200,
        "dmgPct": 15,
        "towers": {
          "human": [
            {
              "x": -15,
              "z": -286
            },
            {
              "x": 15,
              "z": -286
            },
            {
              "x": -15,
              "z": -312
            },
            {
              "x": 15,
              "z": -312
            }
          ],
          "orc": [
            {
              "x": -15,
              "z": 286
            },
            {
              "x": 15,
              "z": 286
            },
            {
              "x": -15,
              "z": 312
            },
            {
              "x": 15,
              "z": 312
            }
          ]
        }
      }
    },
    "schedule": {
      "timezone": "Europe/Istanbul",
      "warnMinutes": [10, 1]
    },
    "bowl": {
      "x": 0,
      "z": 0,
      "floorRadius": 24,
      "radius": 42,
      "depth": 5
    },
    "terrain": {
      "seed": 4040,
      "amplitude": 7,
      "scale": 42,
      "flatRadius": 40,
      "farBoost": 1.8,
      "edgeStart": 360,
      "edgeHeight": 34
    },
    "mobSpawns": [
      {
        "mob": "ash_revenant",
        "x": -70,
        "z": -140,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "ash_revenant",
        "x": -70,
        "z": 140,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "ash_revenant",
        "x": 70,
        "z": -140,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "ash_revenant",
        "x": 70,
        "z": 140,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "hellhound",
        "x": -130,
        "z": -100,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "hellhound",
        "x": -130,
        "z": 100,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "hellhound",
        "x": 125,
        "z": -95,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "hellhound",
        "x": 125,
        "z": 95,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "obsidian_golem",
        "x": -190,
        "z": -55,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "obsidian_golem",
        "x": -190,
        "z": 55,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "obsidian_golem",
        "x": 190,
        "z": -75,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "obsidian_golem",
        "x": 190,
        "z": 75,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "cinder_warden",
        "x": -90,
        "z": -40,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "cinder_warden",
        "x": -90,
        "z": 40,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "cinder_warden",
        "x": 90,
        "z": -45,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "cinder_warden",
        "x": 90,
        "z": 45,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "magma_behemoth",
        "x": -190,
        "z": 0,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "gloom_stalker",
        "x": 150,
        "z": -40,
        "count": 6,
        "radius": 17
      },
      {
        "mob": "gloom_stalker",
        "x": 150,
        "z": 40,
        "count": 6,
        "radius": 17
      },
      {
        "mob": "grak_warlord",
        "x": 186,
        "z": 0,
        "count": 1,
        "radius": 3
      },
      {
        "mob": "ancient_colossus",
        "x": 0,
        "z": 0,
        "count": 1,
        "radius": 2,
        "times": ["13:00", "19:00", "22:00"],
        "place": "the Bowl"
      },
      {
        "mob": "cinder_tyrant",
        "x": -130,
        "z": 0,
        "count": 1,
        "radius": 3
      },
      {
        "mob": "hellmaw",
        "x": 110,
        "z": 0,
        "count": 1,
        "radius": 3
      },
      {
        "mob": "cinder_wyrm",
        "x": -190,
        "z": 0,
        "count": 1,
        "radius": 3
      },
      {
        "mob": "ashen_gladiator",
        "x": 0,
        "z": 0,
        "count": 4,
        "radius": 20
      },
      {
        "mob": "crown_champion",
        "x": 0,
        "z": 0,
        "count": 1,
        "radius": 18
      },
      {
        "mob": "rimefang_wolf",
        "x": -285,
        "z": -100,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "rimefang_wolf",
        "x": -285,
        "z": 100,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "rime_golem",
        "x": -330,
        "z": -45,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "rime_golem",
        "x": -330,
        "z": 45,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "hoarfrost_titan",
        "x": -335,
        "z": 0,
        "count": 1,
        "radius": 3
      },
      {
        "mob": "magma_toad",
        "x": 285,
        "z": -100,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "magma_toad",
        "x": 285,
        "z": 100,
        "count": 9,
        "radius": 19
      },
      {
        "mob": "slag_brute",
        "x": 330,
        "z": -45,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "slag_brute",
        "x": 330,
        "z": 45,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "pyreheart",
        "x": 335,
        "z": 0,
        "count": 1,
        "radius": 3
      }
    ],
    "town": {
      "name": "The Bowl",
      "palette": "ashen",
      "wall": "ruin",
      "plaza": {
        "x": 0,
        "z": 0,
        "radius": 9
      },
      "palisade": {
        "radius": 36,
        "gateAngles": [0, 90, 180, 270],
        "gateWidth": 9,
        "postSpacing": 0.9
      },
      "paths": [
        {
          "width": 3.2,
          "points": [[0, -9], [0, -36], [-12, -100], [0, -170], [0, -223]]
        },
        {
          "width": 3.2,
          "points": [[0, 9], [0, 36], [12, 100], [0, 170], [0, 223]]
        },
        {
          "width": 3.2,
          "points": [[9, 0], [36, 0], [110, -8], [168, 0]]
        },
        {
          "width": 3.2,
          "points": [[0, -249], [0, -294]]
        },
        {
          "width": 3.2,
          "points": [[0, 249], [0, 294]]
        }
      ],
      "structures": [
        {
          "type": "ruin_wall",
          "x": -10,
          "z": 14,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": 10,
          "z": -14,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": 15,
          "z": 9,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": -15,
          "z": -9,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": 22,
          "z": -4,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": -22,
          "z": 4,
          "rot": 90
        },
        {
          "type": "ruin_pillar",
          "x": -8,
          "z": -8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 8,
          "z": 8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -8,
          "z": 8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 8,
          "z": -8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 0,
          "z": 20,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 0,
          "z": -20,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 20,
          "z": 0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -20,
          "z": 0,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": 0,
          "z": 30,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": 0,
          "z": -30,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": 30,
          "z": 0,
          "rot": 90
        },
        {
          "type": "ruin_arch",
          "x": -30,
          "z": 0,
          "rot": 90
        },
        {
          "type": "war_banner_human",
          "x": -6,
          "z": -291,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": 6,
          "z": -291,
          "rot": 0
        },
        {
          "type": "tent",
          "x": -14,
          "z": -304,
          "rot": 90
        },
        {
          "type": "tent",
          "x": 14,
          "z": -304,
          "rot": 270
        },
        {
          "type": "tent",
          "x": -12,
          "z": -314,
          "rot": 45
        },
        {
          "type": "tent",
          "x": 12,
          "z": -314,
          "rot": 315
        },
        {
          "type": "market_stall",
          "x": 0,
          "z": -308,
          "rot": 0
        },
        {
          "type": "campfire",
          "x": 0,
          "z": -299,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -9,
          "z": -294,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 9,
          "z": -294,
          "rot": 0
        },
        {
          "type": "spikes",
          "x": -20,
          "z": -290,
          "rot": 20
        },
        {
          "type": "spikes",
          "x": 20,
          "z": -290,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": -26,
          "z": -298,
          "rot": 60
        },
        {
          "type": "spikes",
          "x": 26,
          "z": -298,
          "rot": 300
        },
        {
          "type": "war_banner_human",
          "x": -18,
          "z": -312,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": 18,
          "z": -312,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": -6,
          "z": 291,
          "rot": 180
        },
        {
          "type": "war_banner_orc",
          "x": 6,
          "z": 291,
          "rot": 180
        },
        {
          "type": "tent",
          "x": -14,
          "z": 304,
          "rot": 270
        },
        {
          "type": "tent",
          "x": 14,
          "z": 304,
          "rot": 90
        },
        {
          "type": "tent",
          "x": -12,
          "z": 314,
          "rot": 225
        },
        {
          "type": "tent",
          "x": 12,
          "z": 314,
          "rot": 135
        },
        {
          "type": "market_stall",
          "x": 0,
          "z": 308,
          "rot": 180
        },
        {
          "type": "campfire",
          "x": 0,
          "z": 299,
          "rot": 180
        },
        {
          "type": "brazier",
          "x": -9,
          "z": 294,
          "rot": 180
        },
        {
          "type": "brazier",
          "x": 9,
          "z": 294,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -20,
          "z": 290,
          "rot": 200
        },
        {
          "type": "spikes",
          "x": 20,
          "z": 290,
          "rot": 160
        },
        {
          "type": "spikes",
          "x": -26,
          "z": 298,
          "rot": 240
        },
        {
          "type": "spikes",
          "x": 26,
          "z": 298,
          "rot": 120
        },
        {
          "type": "skull_pole",
          "x": -4,
          "z": 320,
          "rot": 180
        },
        {
          "type": "skull_pole",
          "x": 4,
          "z": 320,
          "rot": 180
        },
        {
          "type": "skull_pole",
          "x": -18,
          "z": 312,
          "rot": 180
        },
        {
          "type": "skull_pole",
          "x": 18,
          "z": 312,
          "rot": 180
        },
        {
          "type": "tent",
          "x": 178,
          "z": 12,
          "rot": 270
        },
        {
          "type": "tent",
          "x": 178,
          "z": -12,
          "rot": 270
        },
        {
          "type": "tent",
          "x": 196,
          "z": 8,
          "rot": 270
        },
        {
          "type": "tent",
          "x": 196,
          "z": -8,
          "rot": 270
        },
        {
          "type": "bonfire",
          "x": 186,
          "z": 0,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": 170,
          "z": 6,
          "rot": 90
        },
        {
          "type": "war_banner_orc",
          "x": 170,
          "z": -6,
          "rot": 90
        },
        {
          "type": "skull_pole",
          "x": 168,
          "z": 14,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 168,
          "z": -14,
          "rot": 0
        },
        {
          "type": "bone_pile",
          "x": 190,
          "z": 18,
          "rot": 0
        },
        {
          "type": "bone_pile",
          "x": 192,
          "z": -18,
          "rot": 40
        },
        {
          "type": "bridge",
          "x": -150,
          "z": -236,
          "rot": 0
        },
        {
          "type": "bridge",
          "x": -150,
          "z": 236,
          "rot": 0
        },
        {
          "type": "bridge",
          "x": 0,
          "z": -236,
          "rot": 0
        },
        {
          "type": "bridge",
          "x": 0,
          "z": 236,
          "rot": 0
        },
        {
          "type": "bridge",
          "x": 150,
          "z": -236,
          "rot": 0
        },
        {
          "type": "bridge",
          "x": 150,
          "z": 236,
          "rot": 0
        },
        {
          "type": "market_stall",
          "x": -7,
          "z": -306,
          "rot": 0
        },
        {
          "type": "market_stall",
          "x": -7,
          "z": 306,
          "rot": 180
        }
      ]
    },
    "world": {
      "seed": 4041,
      "water": {
        "level": -0.35,
        "depth": 1,
        "rivers": [
          {
            "width": 12,
            "points": [
              [-400, -240],
              [-310, -228],
              [-230, -244],
              [-172, -236],
              [-128, -236],
              [-70, -246],
              [-22, -236],
              [22, -236],
              [70, -228],
              [128, -236],
              [172, -236],
              [230, -246],
              [310, -232],
              [400, -240]
            ]
          },
          {
            "width": 12,
            "points": [
              [-400, 240],
              [-310, 228],
              [-230, 244],
              [-172, 236],
              [-128, 236],
              [-70, 246],
              [-22, 236],
              [22, 236],
              [70, 228],
              [128, 236],
              [172, 236],
              [230, 246],
              [310, 232],
              [400, 240]
            ]
          }
        ],
        "lakes": [
          {
            "x": -120,
            "z": -150,
            "r": 18
          },
          {
            "x": 120,
            "z": 150,
            "r": 18
          }
        ]
      },
      "regions": [
        {
          "name": "Colony Wastes",
          "biome": "pine_forest",
          "x": 0,
          "z": 0,
          "r": 300,
          "density": 0.55
        },
        {
          "name": "The Scorched Heart",
          "biome": "ashland",
          "x": 0,
          "z": 0,
          "r": 95,
          "density": 0.35
        },
        {
          "biome": "graveyard",
          "x": -70,
          "z": -140,
          "r": 30,
          "density": 1.2,
          "name": "Revenant Barrows"
        },
        {
          "biome": "graveyard",
          "x": -70,
          "z": 140,
          "r": 30,
          "density": 1.2,
          "name": "Barrows of the North"
        },
        {
          "biome": "pine_forest",
          "x": 70,
          "z": -140,
          "r": 34,
          "density": 2.2,
          "name": "Ashwood"
        },
        {
          "biome": "pine_forest",
          "x": 70,
          "z": 140,
          "r": 34,
          "density": 2.2,
          "name": "Deadpine Thicket"
        },
        {
          "biome": "rocky",
          "x": -130,
          "z": -100,
          "r": 38,
          "density": 1.4,
          "name": "Hellfire Gorge"
        },
        {
          "biome": "rocky",
          "x": -130,
          "z": 100,
          "r": 38,
          "density": 1.4,
          "name": "Cinder Ridge"
        },
        {
          "biome": "rocky",
          "x": 125,
          "z": -95,
          "r": 36,
          "density": 1.4,
          "name": "Blackglass Fields"
        },
        {
          "biome": "rocky",
          "x": 125,
          "z": 95,
          "r": 36,
          "density": 1.4,
          "name": "Emberglass Fields"
        },
        {
          "biome": "rocky",
          "x": -200,
          "z": 0,
          "r": 80,
          "density": 1.3,
          "name": "Obsidian Scar"
        },
        {
          "biome": "rocky",
          "x": 150,
          "z": 0,
          "r": 50,
          "density": 1.3,
          "name": "Stonewatch Hills"
        },
        {
          "name": "Warlord's Camp",
          "biome": "ashland",
          "x": 186,
          "z": 0,
          "r": 26,
          "density": 0.1
        },
        {
          "name": "Human Outpost",
          "biome": "meadow",
          "x": 0,
          "z": -300,
          "r": 30,
          "density": 0.2
        },
        {
          "name": "Orc Outpost",
          "biome": "ashland",
          "x": 0,
          "z": 300,
          "r": 30,
          "density": 0.1
        },
        {
          "name": "The Bowl",
          "biome": "ashland",
          "x": 0,
          "z": 0,
          "r": 40,
          "density": 0.1
        },
        {
          "name": "The Tyrant's Pyre",
          "biome": "ashland",
          "x": -130,
          "z": 0,
          "r": 20,
          "density": 0.3
        },
        {
          "name": "Hellmaw's Den",
          "biome": "rocky",
          "x": 110,
          "z": 0,
          "r": 20,
          "density": 0.3
        },
        {
          "name": "Frostfang Glacier",
          "biome": "glacier",
          "x": -320,
          "z": 0,
          "r": 105,
          "density": 0.9
        },
        {
          "name": "Rimewater Fells",
          "biome": "glacier",
          "x": -310,
          "z": -200,
          "r": 62,
          "density": 0.8
        },
        {
          "name": "Hoarfrost Fells",
          "biome": "glacier",
          "x": -310,
          "z": 200,
          "r": 62,
          "density": 0.8
        },
        {
          "name": "The Molten Wastes",
          "biome": "lava",
          "x": 320,
          "z": 0,
          "r": 105,
          "density": 0.8
        },
        {
          "name": "Scorchfall Flats",
          "biome": "lava",
          "x": 310,
          "z": -200,
          "r": 62,
          "density": 0.7
        },
        {
          "name": "Emberflow Flats",
          "biome": "lava",
          "x": 310,
          "z": 200,
          "r": 62,
          "density": 0.7
        },
        {
          "name": "Southwater Woods",
          "biome": "forest",
          "x": -110,
          "z": -275,
          "r": 40,
          "density": 1.6
        },
        {
          "name": "Southwater Woods",
          "biome": "forest",
          "x": 110,
          "z": -275,
          "r": 40,
          "density": 1.6
        },
        {
          "name": "Northwater Woods",
          "biome": "pine_forest",
          "x": -110,
          "z": 275,
          "r": 40,
          "density": 1.6
        },
        {
          "name": "Northwater Woods",
          "biome": "pine_forest",
          "x": 110,
          "z": 275,
          "r": 40,
          "density": 1.6
        },
        {
          "name": "Southwater Ford",
          "biome": "marsh",
          "x": 0,
          "z": -236,
          "r": 30,
          "density": 0.5
        },
        {
          "name": "Northwater Ford",
          "biome": "marsh",
          "x": 0,
          "z": 236,
          "r": 30,
          "density": 0.5
        }
      ],
      "groundCover": 0.45,
      "clearings": [
        {
          "x": 0,
          "z": -300,
          "r": 34
        },
        {
          "x": 0,
          "z": 300,
          "r": 34
        },
        {
          "x": 186,
          "z": 0,
          "r": 26
        },
        {
          "x": 0,
          "z": 0,
          "r": 42
        },
        {
          "x": -70,
          "z": -140,
          "r": 18
        },
        {
          "x": -70,
          "z": 140,
          "r": 18
        },
        {
          "x": 70,
          "z": -140,
          "r": 18
        },
        {
          "x": 70,
          "z": 140,
          "r": 18
        },
        {
          "x": -130,
          "z": -100,
          "r": 18
        },
        {
          "x": -130,
          "z": 100,
          "r": 18
        },
        {
          "x": 125,
          "z": -95,
          "r": 18
        },
        {
          "x": 125,
          "z": 95,
          "r": 18
        },
        {
          "x": -190,
          "z": -55,
          "r": 17
        },
        {
          "x": -190,
          "z": 55,
          "r": 17
        },
        {
          "x": 190,
          "z": -75,
          "r": 17
        },
        {
          "x": 190,
          "z": 75,
          "r": 17
        },
        {
          "x": -90,
          "z": -40,
          "r": 17
        },
        {
          "x": -90,
          "z": 40,
          "r": 17
        },
        {
          "x": 90,
          "z": -45,
          "r": 17
        },
        {
          "x": 90,
          "z": 45,
          "r": 17
        },
        {
          "x": -190,
          "z": 0,
          "r": 18
        },
        {
          "x": 150,
          "z": -40,
          "r": 16
        },
        {
          "x": 150,
          "z": 40,
          "r": 16
        },
        {
          "x": -130,
          "z": 0,
          "r": 16
        },
        {
          "x": 110,
          "z": 0,
          "r": 16
        },
        {
          "x": -285,
          "z": -100,
          "r": 18
        },
        {
          "x": -285,
          "z": 100,
          "r": 18
        },
        {
          "x": -330,
          "z": -45,
          "r": 17
        },
        {
          "x": -330,
          "z": 45,
          "r": 17
        },
        {
          "x": -335,
          "z": 0,
          "r": 5
        },
        {
          "x": 285,
          "z": -100,
          "r": 18
        },
        {
          "x": 285,
          "z": 100,
          "r": 18
        },
        {
          "x": 330,
          "z": -45,
          "r": 17
        },
        {
          "x": 330,
          "z": 45,
          "r": 17
        },
        {
          "x": 335,
          "z": 0,
          "r": 5
        },
        {
          "x": -150,
          "z": -236,
          "r": 14
        },
        {
          "x": -150,
          "z": 236,
          "r": 14
        },
        {
          "x": 0,
          "z": -236,
          "r": 14
        },
        {
          "x": 0,
          "z": 236,
          "r": 14
        },
        {
          "x": 150,
          "z": -236,
          "r": 14
        },
        {
          "x": 150,
          "z": 236,
          "r": 14
        }
      ]
    },
    "portals": [
      {
        "x": 0,
        "z": -320,
        "rot": 0,
        "label": "Travel gate"
      },
      {
        "x": 0,
        "z": 320,
        "rot": 180,
        "label": "Travel gate"
      },
      {
        "x": 12,
        "z": 0,
        "rot": 270,
        "label": "Rift Gate",
        "only": "umbral_rift"
      }
    ],
    "minLevel": 40
  },
  {
    "id": "umbral_rift",
    "name": "The Umbral Rift",
    "size": 320,
    "pvp": true,
    "spawn": {
      "x": 0,
      "z": -118
    },
    "spawnRadius": 4,
    "playerCap": 200,
    "bases": {
      "human": {
        "x": 0,
        "z": -118
      },
      "orc": {
        "x": 0,
        "z": 118
      },
      "safeRadius": 16,
      "guard": {
        "radius": 26,
        "everyMs": 1200,
        "dmgPct": 8,
        "towers": {
          "human": [
            {
              "x": -11,
              "z": -108
            },
            {
              "x": 11,
              "z": -108
            },
            {
              "x": -11,
              "z": -126
            },
            {
              "x": 11,
              "z": -126
            }
          ],
          "orc": [
            {
              "x": -11,
              "z": 108
            },
            {
              "x": 11,
              "z": 108
            },
            {
              "x": -11,
              "z": 126
            },
            {
              "x": 11,
              "z": 126
            }
          ]
        }
      }
    },
    "terrain": {
      "seed": 8080,
      "amplitude": 9,
      "scale": 38,
      "flatRadius": 24,
      "farBoost": 2,
      "edgeStart": 148,
      "edgeHeight": 36
    },
    "mobSpawns": [
      {
        "mob": "rift_shade",
        "x": -60,
        "z": -60,
        "count": 9,
        "radius": 18
      },
      {
        "mob": "rift_shade",
        "x": 60,
        "z": 60,
        "count": 9,
        "radius": 18
      },
      {
        "mob": "rift_shade",
        "x": -95,
        "z": 20,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "rift_shade",
        "x": 95,
        "z": -20,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "duskbound_sentinel",
        "x": 60,
        "z": -60,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "duskbound_sentinel",
        "x": -60,
        "z": 60,
        "count": 8,
        "radius": 18
      },
      {
        "mob": "voidstone_golem",
        "x": -110,
        "z": -75,
        "count": 6,
        "radius": 18
      },
      {
        "mob": "voidstone_golem",
        "x": 110,
        "z": 75,
        "count": 6,
        "radius": 18
      },
      {
        "mob": "voidstone_golem",
        "x": -110,
        "z": 75,
        "count": 6,
        "radius": 18
      },
      {
        "mob": "voidstone_golem",
        "x": 110,
        "z": -75,
        "count": 6,
        "radius": 18
      },
      {
        "mob": "riftborn_stalker",
        "x": 0,
        "z": 0,
        "count": 8,
        "radius": 22
      },
      {
        "mob": "riftborn_stalker",
        "x": -45,
        "z": 0,
        "count": 6,
        "radius": 16
      },
      {
        "mob": "riftborn_stalker",
        "x": 45,
        "z": 0,
        "count": 6,
        "radius": 16
      }
    ],
    "world": {
      "seed": 8081,
      "water": {
        "level": -0.35,
        "depth": 1,
        "rivers": [],
        "lakes": []
      },
      "regions": [
        {
          "name": "The Umbral Rift",
          "biome": "ashland",
          "x": 0,
          "z": 0,
          "r": 220,
          "density": 0.5
        },
        {
          "name": "Hall of Shades",
          "biome": "graveyard",
          "x": -60,
          "z": -60,
          "r": 30,
          "density": 1.1
        },
        {
          "name": "Hall of Echoes",
          "biome": "graveyard",
          "x": 60,
          "z": 60,
          "r": 30,
          "density": 1.1
        },
        {
          "name": "Sentinel Ruins",
          "biome": "rocky",
          "x": 60,
          "z": -60,
          "r": 30,
          "density": 1.2
        },
        {
          "name": "Fallen Watch",
          "biome": "rocky",
          "x": -60,
          "z": 60,
          "r": 30,
          "density": 1.2
        },
        {
          "name": "Voidstone Scar",
          "biome": "rocky",
          "x": -110,
          "z": 0,
          "r": 45,
          "density": 1.4
        },
        {
          "name": "Voidstone Rise",
          "biome": "rocky",
          "x": 110,
          "z": 0,
          "r": 45,
          "density": 1.4
        },
        {
          "name": "The Heart of the Rift",
          "biome": "ashland",
          "x": 0,
          "z": 0,
          "r": 40,
          "density": 0.15
        },
        {
          "name": "Human Refuge",
          "biome": "ashland",
          "x": 0,
          "z": -118,
          "r": 22,
          "density": 0.05
        },
        {
          "name": "Orc Refuge",
          "biome": "ashland",
          "x": 0,
          "z": 118,
          "r": 22,
          "density": 0.05
        }
      ],
      "groundCover": 0.3,
      "clearings": [
        {
          "x": 0,
          "z": -118,
          "r": 24
        },
        {
          "x": 0,
          "z": 118,
          "r": 24
        },
        {
          "x": 0,
          "z": 0,
          "r": 22
        },
        {
          "x": -60,
          "z": -60,
          "r": 14
        },
        {
          "x": 60,
          "z": 60,
          "r": 14
        },
        {
          "x": 60,
          "z": -60,
          "r": 14
        },
        {
          "x": -60,
          "z": 60,
          "r": 14
        },
        {
          "x": -45,
          "z": 0,
          "r": 10
        },
        {
          "x": 45,
          "z": 0,
          "r": 10
        }
      ]
    },
    "mood": "void",
    "portals": [
      {
        "x": 0,
        "z": -130,
        "rot": 0,
        "label": "Way back",
        "only": "colony_zone"
      },
      {
        "x": 0,
        "z": 130,
        "rot": 180,
        "label": "Way back",
        "only": "colony_zone"
      }
    ],
    "minLevel": 50,
    "timed": {
      "from": "colony_zone",
      "timezone": "Europe/Istanbul",
      "opens": ["16:00", "20:30"],
      "openMinutes": 20,
      "stayMinutes": 60
    }
  },
  {
    "id": "morgard",
    "name": "Morgard",
    "size": 560,
    "pvp": true,
    "spawn": {
      "x": 0,
      "z": 0
    },
    "spawnRadius": 4,
    "playerCap": 120,
    "bases": {
      "human": {
        "x": 0,
        "z": -235
      },
      "orc": {
        "x": 0,
        "z": 235
      },
      "safeRadius": 20,
      "guard": {
        "radius": 30,
        "everyMs": 1200,
        "dmgPct": 8,
        "towers": {
          "human": [
            {
              "x": -13,
              "z": -223
            },
            {
              "x": 13,
              "z": -223
            },
            {
              "x": -13,
              "z": -249
            },
            {
              "x": 13,
              "z": -249
            }
          ],
          "orc": [
            {
              "x": -13,
              "z": 223
            },
            {
              "x": 13,
              "z": 223
            },
            {
              "x": -13,
              "z": 249
            },
            {
              "x": 13,
              "z": 249
            }
          ]
        }
      }
    },
    "terrain": {
      "seed": 7070,
      "amplitude": 6,
      "scale": 40,
      "flatRadius": 36,
      "farBoost": 1.4,
      "edgeStart": 250,
      "edgeHeight": 30
    },
    "mobSpawns": [],
    "town": {
      "name": "Ruins of Morgard",
      "palette": "ashen",
      "wall": "ruin",
      "plaza": {
        "x": 0,
        "z": 0,
        "radius": 8
      },
      "palisade": {
        "radius": 34,
        "gateAngles": [0, 90, 180, 270],
        "gateWidth": 10,
        "postSpacing": 0.9
      },
      "paths": [
        {
          "width": 3.4,
          "points": [
            [0, -225],
            [-22, -212],
            [-38, -192],
            [-38, -166],
            [-24, -166],
            [0, -166],
            [0, -148],
            [-6, -130],
            [0, -109],
            [0, -81],
            [4, -60],
            [0, -34]
          ]
        },
        {
          "width": 3.4,
          "points": [
            [0, 225],
            [22, 212],
            [38, 192],
            [38, 166],
            [24, 166],
            [0, 166],
            [0, 148],
            [6, 130],
            [0, 109],
            [0, 81],
            [-4, 60],
            [0, 34]
          ]
        },
        {
          "width": 3,
          "points": [[-27, -166], [-90, -150], [-120, -109], [-120, -81], [-110, -40], [-34, 0]]
        },
        {
          "width": 3,
          "points": [[27, -166], [90, -150], [120, -109], [120, -81], [110, -40], [34, 0]]
        },
        {
          "width": 3,
          "points": [[-27, 166], [-90, 150], [-120, 109], [-120, 81], [-110, 40], [-34, 0]]
        },
        {
          "width": 3,
          "points": [[27, 166], [90, 150], [120, 109], [120, 81], [110, 40], [34, 0]]
        }
      ],
      "structures": [
        {
          "type": "bridge",
          "x": -120,
          "z": -95,
          "rot": 0
        },
        {
          "type": "spikes",
          "x": -127,
          "z": -111,
          "rot": 20
        },
        {
          "type": "spikes",
          "x": -113,
          "z": -111,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": -127,
          "z": -79,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": -113,
          "z": -79,
          "rot": 20
        },
        {
          "type": "bridge",
          "x": 0,
          "z": -95,
          "rot": 0
        },
        {
          "type": "spikes",
          "x": -7,
          "z": -111,
          "rot": 20
        },
        {
          "type": "spikes",
          "x": 7,
          "z": -111,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": -7,
          "z": -79,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": 7,
          "z": -79,
          "rot": 20
        },
        {
          "type": "bridge",
          "x": 120,
          "z": -95,
          "rot": 0
        },
        {
          "type": "spikes",
          "x": 113,
          "z": -111,
          "rot": 20
        },
        {
          "type": "spikes",
          "x": 127,
          "z": -111,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": 113,
          "z": -79,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": 127,
          "z": -79,
          "rot": 20
        },
        {
          "type": "bridge",
          "x": -120,
          "z": 95,
          "rot": 0
        },
        {
          "type": "spikes",
          "x": -127,
          "z": 79,
          "rot": 20
        },
        {
          "type": "spikes",
          "x": -113,
          "z": 79,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": -127,
          "z": 111,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": -113,
          "z": 111,
          "rot": 20
        },
        {
          "type": "bridge",
          "x": 0,
          "z": 95,
          "rot": 0
        },
        {
          "type": "spikes",
          "x": -7,
          "z": 79,
          "rot": 20
        },
        {
          "type": "spikes",
          "x": 7,
          "z": 79,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": -7,
          "z": 111,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": 7,
          "z": 111,
          "rot": 20
        },
        {
          "type": "bridge",
          "x": 120,
          "z": 95,
          "rot": 0
        },
        {
          "type": "spikes",
          "x": 113,
          "z": 79,
          "rot": 20
        },
        {
          "type": "spikes",
          "x": 127,
          "z": 79,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": 113,
          "z": 111,
          "rot": 340
        },
        {
          "type": "spikes",
          "x": 127,
          "z": 111,
          "rot": 20
        },
        {
          "type": "ruin_pillar",
          "x": 6.2,
          "z": 19.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 16.2,
          "z": 11.8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 20.0,
          "z": 0.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 16.2,
          "z": -11.8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 6.2,
          "z": -19.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -6.2,
          "z": -19.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -16.2,
          "z": -11.8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -20.0,
          "z": -0.0,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -16.2,
          "z": 11.8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -6.2,
          "z": 19.0,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": 0,
          "z": 27,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": 0,
          "z": -27,
          "rot": 180
        },
        {
          "type": "ruin_arch",
          "x": 27,
          "z": 0,
          "rot": 90
        },
        {
          "type": "ruin_arch",
          "x": -27,
          "z": 0,
          "rot": 270
        },
        {
          "type": "statue",
          "x": 0,
          "z": 0,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -11,
          "z": 9,
          "rot": 30
        },
        {
          "type": "ruin_wall",
          "x": 12,
          "z": -8,
          "rot": 210
        },
        {
          "type": "ruin_wall",
          "x": -10,
          "z": -12,
          "rot": 120
        },
        {
          "type": "ruin_wall",
          "x": 9,
          "z": 13,
          "rot": 300
        },
        {
          "type": "brazier",
          "x": -4,
          "z": 5,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 4,
          "z": -5,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -70,
          "z": -62,
          "rot": 15
        },
        {
          "type": "ruin_wall",
          "x": -38,
          "z": -55,
          "rot": 350
        },
        {
          "type": "ruin_wall",
          "x": 40,
          "z": -55,
          "rot": 10
        },
        {
          "type": "ruin_wall",
          "x": 74,
          "z": -62,
          "rot": 345
        },
        {
          "type": "cart",
          "x": -150,
          "z": -45,
          "rot": 330
        },
        {
          "type": "crate",
          "x": -146,
          "z": -50,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": -153,
          "z": -50,
          "rot": 0
        },
        {
          "type": "cart",
          "x": 150,
          "z": -40,
          "rot": 30
        },
        {
          "type": "boulder",
          "x": 95,
          "z": -30,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": -92,
          "z": -26,
          "rot": 0
        },
        {
          "type": "tree_dead",
          "x": -40,
          "z": -75,
          "rot": 0
        },
        {
          "type": "tree_dead",
          "x": 48,
          "z": -78,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -70,
          "z": 62,
          "rot": 15
        },
        {
          "type": "ruin_wall",
          "x": -38,
          "z": 55,
          "rot": 350
        },
        {
          "type": "ruin_wall",
          "x": 40,
          "z": 55,
          "rot": 10
        },
        {
          "type": "ruin_wall",
          "x": 74,
          "z": 62,
          "rot": 345
        },
        {
          "type": "cart",
          "x": -150,
          "z": 45,
          "rot": 30
        },
        {
          "type": "crate",
          "x": -146,
          "z": 50,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": -153,
          "z": 50,
          "rot": 0
        },
        {
          "type": "cart",
          "x": 150,
          "z": 40,
          "rot": 330
        },
        {
          "type": "boulder",
          "x": 95,
          "z": 30,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": -92,
          "z": 26,
          "rot": 0
        },
        {
          "type": "tree_dead",
          "x": -40,
          "z": 75,
          "rot": 0
        },
        {
          "type": "tree_dead",
          "x": 48,
          "z": 78,
          "rot": 0
        },
        {
          "type": "crypt",
          "x": -185,
          "z": 0,
          "rot": 90
        },
        {
          "type": "tower",
          "x": -160,
          "z": -30,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -160,
          "z": 30,
          "rot": 90
        },
        {
          "type": "standing_stone",
          "x": -205,
          "z": 40,
          "rot": 0
        },
        {
          "type": "standing_stone",
          "x": -205,
          "z": -40,
          "rot": 0
        },
        {
          "type": "cliff",
          "x": 175,
          "z": -20,
          "rot": 20
        },
        {
          "type": "cliff",
          "x": 190,
          "z": 18,
          "rot": 110
        },
        {
          "type": "cliff",
          "x": 160,
          "z": 40,
          "rot": 60
        },
        {
          "type": "cliff",
          "x": 205,
          "z": -45,
          "rot": 150
        },
        {
          "type": "boulder",
          "x": 150,
          "z": -8,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": 182,
          "z": 55,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": 170,
          "z": -60,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -11,
          "z": -150,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -17,
          "z": -150,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -23,
          "z": -150,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": 11,
          "z": -150,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": 17,
          "z": -150,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": 23,
          "z": -150,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -27,
          "z": -154,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": -27,
          "z": -160,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": -27,
          "z": -172,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": -27,
          "z": -178,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": -27,
          "z": -184,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": 27,
          "z": -154,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": 27,
          "z": -160,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": 27,
          "z": -172,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": 27,
          "z": -178,
          "rot": 90
        },
        {
          "type": "ruin_wall",
          "x": 27,
          "z": -184,
          "rot": 90
        },
        {
          "type": "tower",
          "x": -27,
          "z": -148,
          "rot": 0,
          "nation": "human"
        },
        {
          "type": "tower",
          "x": 27,
          "z": -148,
          "rot": 0,
          "nation": "human"
        },
        {
          "type": "keep",
          "x": 0,
          "z": -198,
          "rot": 0,
          "nation": "human"
        },
        {
          "type": "war_banner_human",
          "x": -6,
          "z": -148,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": 6,
          "z": -148,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": -20,
          "z": -188,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": 20,
          "z": -188,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -14,
          "z": -174,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 14,
          "z": -174,
          "rot": 0
        },
        {
          "type": "barracks",
          "x": 46,
          "z": -192,
          "rot": 270,
          "nation": "human"
        },
        {
          "type": "training_dummy",
          "x": -44,
          "z": -150,
          "rot": 0
        },
        {
          "type": "archery_target",
          "x": 50,
          "z": -144,
          "rot": 270
        },
        {
          "type": "spikes",
          "x": -11,
          "z": 150,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -15,
          "z": 150,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -19,
          "z": 150,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -23,
          "z": 150,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": 11,
          "z": 150,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": 15,
          "z": 150,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": 19,
          "z": 150,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": 23,
          "z": 150,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -9,
          "z": 147.8,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -13,
          "z": 147.8,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -17,
          "z": 147.8,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -21,
          "z": 147.8,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": 13,
          "z": 147.8,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": 17,
          "z": 147.8,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": 21,
          "z": 147.8,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": 25,
          "z": 147.8,
          "rot": 180
        },
        {
          "type": "spikes",
          "x": -27,
          "z": 154,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -29.2,
          "z": 154,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -27,
          "z": 158,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -29.2,
          "z": 158,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -27,
          "z": 162,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -29.2,
          "z": 162,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -27,
          "z": 172,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -29.2,
          "z": 172,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -27,
          "z": 176,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -29.2,
          "z": 176,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -27,
          "z": 180,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -29.2,
          "z": 180,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -27,
          "z": 184,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": -29.2,
          "z": 184,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 27,
          "z": 154,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 29.2,
          "z": 154,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 27,
          "z": 158,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 29.2,
          "z": 158,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 27,
          "z": 162,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 29.2,
          "z": 162,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 27,
          "z": 172,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 29.2,
          "z": 172,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 27,
          "z": 176,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 29.2,
          "z": 176,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 27,
          "z": 180,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 29.2,
          "z": 180,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 27,
          "z": 184,
          "rot": 90
        },
        {
          "type": "spikes",
          "x": 29.2,
          "z": 184,
          "rot": 90
        },
        {
          "type": "totem",
          "x": -27,
          "z": 148,
          "rot": 0
        },
        {
          "type": "totem",
          "x": 27,
          "z": 148,
          "rot": 0
        },
        {
          "type": "totem",
          "x": -7,
          "z": 147,
          "rot": 0
        },
        {
          "type": "totem",
          "x": 7,
          "z": 147,
          "rot": 0
        },
        {
          "type": "totem",
          "x": -27,
          "z": 188,
          "rot": 0
        },
        {
          "type": "totem",
          "x": 27,
          "z": 188,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -24,
          "z": 145,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -17,
          "z": 145,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 17,
          "z": 145,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 24,
          "z": 145,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -30,
          "z": 160,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 30,
          "z": 160,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -30,
          "z": 178,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 30,
          "z": 178,
          "rot": 0
        },
        {
          "type": "longhouse",
          "x": 0,
          "z": 198,
          "rot": 180,
          "nation": "orc"
        },
        {
          "type": "war_banner_orc",
          "x": -6,
          "z": 148,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": 6,
          "z": 148,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": -20,
          "z": 188,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": 20,
          "z": 188,
          "rot": 0
        },
        {
          "type": "bonfire",
          "x": -14,
          "z": 174,
          "rot": 0
        },
        {
          "type": "bonfire",
          "x": 14,
          "z": 174,
          "rot": 0
        },
        {
          "type": "orc_hut",
          "x": -20,
          "z": 182,
          "rot": 120
        },
        {
          "type": "orc_hut",
          "x": 20,
          "z": 182,
          "rot": 240
        },
        {
          "type": "tent",
          "x": -18,
          "z": 162,
          "rot": 90
        },
        {
          "type": "tent",
          "x": 18,
          "z": 162,
          "rot": 270
        },
        {
          "type": "bone_pile",
          "x": -10,
          "z": 184,
          "rot": 0
        },
        {
          "type": "bone_pile",
          "x": 10,
          "z": 158,
          "rot": 0
        },
        {
          "type": "orc_hut",
          "x": -44,
          "z": 182,
          "rot": 90
        },
        {
          "type": "orc_hut",
          "x": -46,
          "z": 198,
          "rot": 90
        },
        {
          "type": "bone_pile",
          "x": -40,
          "z": 158,
          "rot": 0
        },
        {
          "type": "bone_pile",
          "x": 44,
          "z": 156,
          "rot": 0
        },
        {
          "type": "woodpile",
          "x": -36,
          "z": 192,
          "rot": 90
        },
        {
          "type": "brazier",
          "x": 34,
          "z": 150,
          "rot": 0
        },
        {
          "type": "tent",
          "x": -14,
          "z": -239,
          "rot": 90
        },
        {
          "type": "tent",
          "x": 14,
          "z": -239,
          "rot": 270
        },
        {
          "type": "tent",
          "x": -12,
          "z": -227,
          "rot": 45
        },
        {
          "type": "tent",
          "x": 12,
          "z": -227,
          "rot": 315
        },
        {
          "type": "campfire",
          "x": 0,
          "z": -229,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": -9,
          "z": -221,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": 9,
          "z": -221,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -18,
          "z": -235,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 18,
          "z": -235,
          "rot": 0
        },
        {
          "type": "tent",
          "x": -14,
          "z": 239,
          "rot": 270
        },
        {
          "type": "tent",
          "x": 14,
          "z": 239,
          "rot": 90
        },
        {
          "type": "tent",
          "x": -12,
          "z": 227,
          "rot": 225
        },
        {
          "type": "tent",
          "x": 12,
          "z": 227,
          "rot": 135
        },
        {
          "type": "campfire",
          "x": 0,
          "z": 229,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": -9,
          "z": 221,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": 9,
          "z": 221,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -18,
          "z": 235,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 18,
          "z": 235,
          "rot": 0
        },
        {
          "type": "market_stall",
          "x": -5,
          "z": -241,
          "rot": 0
        },
        {
          "type": "market_stall",
          "x": -5,
          "z": 241,
          "rot": 180
        }
      ]
    },
    "world": {
      "seed": 7071,
      "water": {
        "level": -0.35,
        "depth": 1,
        "rivers": [
          {
            "width": 12,
            "points": [
              [-280, -100],
              [-200, -88],
              [-150, -97],
              [-120, -95],
              [-60, -103],
              [0, -95],
              [60, -88],
              [120, -95],
              [170, -92],
              [230, -104],
              [280, -96]
            ]
          },
          {
            "width": 12,
            "points": [
              [-280, 100],
              [-200, 88],
              [-150, 97],
              [-120, 95],
              [-60, 103],
              [0, 95],
              [60, 88],
              [120, 95],
              [170, 92],
              [230, 104],
              [280, 96]
            ]
          }
        ],
        "lakes": []
      },
      "regions": [
        {
          "name": "Morgard",
          "biome": "ashland",
          "x": 0,
          "z": 0,
          "r": 300,
          "density": 0.3
        },
        {
          "name": "Valcrest Reach",
          "biome": "meadow",
          "x": 0,
          "z": -190,
          "r": 90,
          "density": 0.35
        },
        {
          "name": "Gorzhak Scar",
          "biome": "ashland",
          "x": 0,
          "z": 175,
          "r": 110,
          "density": 0.45
        },
        {
          "name": "Fallen Fields",
          "biome": "graveyard",
          "x": -180,
          "z": 0,
          "r": 60,
          "density": 1.1
        },
        {
          "name": "Broken Crags",
          "biome": "rocky",
          "x": 180,
          "z": 0,
          "r": 60,
          "density": 1.2
        },
        {
          "name": "Bloodwater Ford",
          "biome": "marsh",
          "x": 0,
          "z": -95,
          "r": 26,
          "density": 0.6
        },
        {
          "name": "Bloodwater Ford",
          "biome": "marsh",
          "x": 0,
          "z": 95,
          "r": 26,
          "density": 0.6
        },
        {
          "name": "Human Camp",
          "biome": "meadow",
          "x": 0,
          "z": -235,
          "r": 28,
          "density": 0.2
        },
        {
          "name": "Orc Camp",
          "biome": "ashland",
          "x": 0,
          "z": 235,
          "r": 28,
          "density": 0.2
        },
        {
          "name": "Valcrest Bastion",
          "biome": "meadow",
          "x": 0,
          "z": -170,
          "r": 34,
          "density": 0.15
        },
        {
          "name": "Gorzhak Stronghold",
          "biome": "ashland",
          "x": 0,
          "z": 170,
          "r": 34,
          "density": 0.15
        }
      ],
      "groundCover": 0.35,
      "clearings": [
        {
          "x": 0,
          "z": -235,
          "r": 32
        },
        {
          "x": 0,
          "z": 235,
          "r": 32
        },
        {
          "x": 0,
          "z": -170,
          "r": 40
        },
        {
          "x": 0,
          "z": 170,
          "r": 40
        },
        {
          "x": 0,
          "z": 0,
          "r": 40
        },
        {
          "x": -120,
          "z": -95,
          "r": 20
        },
        {
          "x": 0,
          "z": -95,
          "r": 20
        },
        {
          "x": 120,
          "z": -95,
          "r": 20
        },
        {
          "x": -120,
          "z": 95,
          "r": 20
        },
        {
          "x": 0,
          "z": 95,
          "r": 20
        },
        {
          "x": 120,
          "z": 95,
          "r": 20
        },
        {
          "x": -40,
          "z": -200,
          "r": 16
        },
        {
          "x": 40,
          "z": 200,
          "r": 16
        }
      ]
    },
    "portals": [
      {
        "x": 0,
        "z": -253,
        "rot": 0,
        "label": "Way back",
        "only": "dev_field"
      },
      {
        "x": 0,
        "z": 253,
        "rot": 180,
        "label": "Way back",
        "only": "dev_field"
      }
    ],
    "war": {
      "days": [3, 6],
      "start": "21:00",
      "timezone": "Europe/Istanbul",
      "minutes": 60,
      "warnMinutes": [10, 1],
      "keepers": {
        "human": {
          "mob": "war_keeper_human",
          "x": 0,
          "z": -174
        },
        "orc": {
          "mob": "war_keeper_orc",
          "x": 0,
          "z": 174
        }
      },
      "returnTo": "dev_field",
      "closes": ["colony_zone"],
      "endAfterWinMs": 60000,
      "keeperReturnMs": 15000,
      "bonusPct": {
        "xp": 5,
        "gold": 5,
        "drop": 5
      }
    },
    "minLevel": 40
  },
  {
    "id": "crystal_clash",
    "name": "Crystal Clash",
    "size": 150,
    "spawn": {
      "x": 0,
      "z": 0
    },
    "spawnRadius": 4,
    "playerCap": 20,
    "pvp": true,
    "bases": {
      "human": {
        "x": 0,
        "z": -58
      },
      "orc": {
        "x": 0,
        "z": 58
      },
      "safeRadius": 12,
      "guard": {
        "radius": 20,
        "everyMs": 1200,
        "dmgPct": 8,
        "towers": {
          "human": [
            {
              "x": -8,
              "z": -50
            },
            {
              "x": 8,
              "z": -50
            },
            {
              "x": -8,
              "z": -66
            },
            {
              "x": 8,
              "z": -66
            }
          ],
          "orc": [
            {
              "x": -8,
              "z": 50
            },
            {
              "x": 8,
              "z": 50
            },
            {
              "x": -8,
              "z": 66
            },
            {
              "x": 8,
              "z": 66
            }
          ]
        }
      }
    },
    "terrain": {
      "seed": 9090,
      "amplitude": 2.5,
      "scale": 30,
      "flatRadius": 22,
      "farBoost": 1.2,
      "edgeStart": 68,
      "edgeHeight": 24
    },
    "mobSpawns": [],
    "town": {
      "name": "The Shard Ring",
      "palette": "ashen",
      "wall": "ruin",
      "plaza": {
        "x": 0,
        "z": 0,
        "radius": 5
      },
      "palisade": {
        "radius": 16,
        "gateAngles": [0, 90, 180, 270],
        "gateWidth": 8,
        "postSpacing": 0.9
      },
      "paths": [
        {
          "width": 3.2,
          "points": [[0, -46], [0, -36], [-3, -26], [0, -16]]
        },
        {
          "width": 3.2,
          "points": [[0, 46], [0, 36], [3, 26], [0, 16]]
        }
      ],
      "structures": [
        {
          "type": "ruin_pillar",
          "x": 3.8,
          "z": 9.2,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 7.1,
          "z": 7.1,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 9.2,
          "z": 3.8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 9.2,
          "z": -3.8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 7.1,
          "z": -7.1,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": 3.8,
          "z": -9.2,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -3.8,
          "z": -9.2,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -7.1,
          "z": -7.1,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -9.2,
          "z": -3.8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -9.2,
          "z": 3.8,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -7.1,
          "z": 7.1,
          "rot": 0
        },
        {
          "type": "ruin_pillar",
          "x": -3.8,
          "z": 9.2,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": 0,
          "z": 17,
          "rot": 0
        },
        {
          "type": "ruin_arch",
          "x": 0,
          "z": -17,
          "rot": 180
        },
        {
          "type": "brazier",
          "x": 6,
          "z": 6,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -6,
          "z": -6,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 6,
          "z": -6,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -6,
          "z": 6,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -9,
          "z": 22,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": 9,
          "z": 22,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": -24,
          "z": 12,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": 25,
          "z": 10,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": -18,
          "z": 40,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": 20,
          "z": 38,
          "rot": 0
        },
        {
          "type": "standing_stone",
          "x": -34,
          "z": 28,
          "rot": 0
        },
        {
          "type": "standing_stone",
          "x": 34,
          "z": 30,
          "rot": 0
        },
        {
          "type": "tree_dead",
          "x": -38,
          "z": 46,
          "rot": 0
        },
        {
          "type": "tree_dead",
          "x": 40,
          "z": 44,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": -9,
          "z": -22,
          "rot": 0
        },
        {
          "type": "ruin_wall",
          "x": 9,
          "z": -22,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": -24,
          "z": -12,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": 25,
          "z": -10,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": -18,
          "z": -40,
          "rot": 0
        },
        {
          "type": "boulder",
          "x": 20,
          "z": -38,
          "rot": 0
        },
        {
          "type": "standing_stone",
          "x": -34,
          "z": -28,
          "rot": 0
        },
        {
          "type": "standing_stone",
          "x": 34,
          "z": -30,
          "rot": 0
        },
        {
          "type": "tree_dead",
          "x": -38,
          "z": -46,
          "rot": 0
        },
        {
          "type": "tree_dead",
          "x": 40,
          "z": -44,
          "rot": 0
        },
        {
          "type": "tent",
          "x": -18,
          "z": -64,
          "rot": 90
        },
        {
          "type": "tent",
          "x": 18,
          "z": -64,
          "rot": 270
        },
        {
          "type": "tent",
          "x": -18,
          "z": -55,
          "rot": 90
        },
        {
          "type": "tent",
          "x": 18,
          "z": -55,
          "rot": 270
        },
        {
          "type": "campfire",
          "x": -6,
          "z": -64,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": -5,
          "z": -46,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": 5,
          "z": -46,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": -24,
          "z": -60,
          "rot": 0
        },
        {
          "type": "war_banner_human",
          "x": 24,
          "z": -60,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -12,
          "z": -46,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 12,
          "z": -46,
          "rot": 0
        },
        {
          "type": "crate",
          "x": -14,
          "z": -70,
          "rot": 0
        },
        {
          "type": "barrel",
          "x": -16,
          "z": -71,
          "rot": 0
        },
        {
          "type": "cart",
          "x": 14,
          "z": -70,
          "rot": 30
        },
        {
          "type": "tent",
          "x": -18,
          "z": 64,
          "rot": 270
        },
        {
          "type": "tent",
          "x": 18,
          "z": 64,
          "rot": 90
        },
        {
          "type": "tent",
          "x": -18,
          "z": 55,
          "rot": 270
        },
        {
          "type": "tent",
          "x": 18,
          "z": 55,
          "rot": 90
        },
        {
          "type": "bonfire",
          "x": -6,
          "z": 64,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": -5,
          "z": 46,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": 5,
          "z": 46,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": -24,
          "z": 60,
          "rot": 0
        },
        {
          "type": "war_banner_orc",
          "x": 24,
          "z": 60,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": -12,
          "z": 46,
          "rot": 0
        },
        {
          "type": "brazier",
          "x": 12,
          "z": 46,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": -14,
          "z": 70,
          "rot": 0
        },
        {
          "type": "skull_pole",
          "x": 14,
          "z": 70,
          "rot": 0
        },
        {
          "type": "totem",
          "x": -20,
          "z": 70,
          "rot": 0
        }
      ]
    },
    "world": {
      "seed": 9091,
      "water": {
        "level": -0.35,
        "depth": 0.8,
        "rivers": [
          {
            "width": 7,
            "points": [[-80, -28], [-50, -24], [-20, -29], [10, -25], [40, -29], [80, -25]]
          },
          {
            "width": 7,
            "points": [[-80, 28], [-50, 24], [-20, 29], [10, 25], [40, 29], [80, 25]]
          }
        ],
        "lakes": []
      },
      "regions": [
        {
          "name": "Crystal Clash",
          "biome": "meadow",
          "x": 0,
          "z": 0,
          "r": 110,
          "density": 0.25
        },
        {
          "name": "The Shard Ring",
          "biome": "ashland",
          "x": 0,
          "z": 0,
          "r": 20,
          "density": 0.1
        },
        {
          "name": "Valcrest Camp",
          "biome": "meadow",
          "x": 0,
          "z": -58,
          "r": 18,
          "density": 0.1
        },
        {
          "name": "Gorzhak Camp",
          "biome": "ashland",
          "x": 0,
          "z": 58,
          "r": 18,
          "density": 0.1
        }
      ],
      "groundCover": 0.35,
      "clearings": [
        {
          "x": 0,
          "z": 0,
          "r": 20
        },
        {
          "x": 0,
          "z": -58,
          "r": 22
        },
        {
          "x": 0,
          "z": 58,
          "r": 22
        },
        {
          "x": 0,
          "z": -26,
          "r": 8
        },
        {
          "x": 0,
          "z": 26,
          "r": 8
        }
      ]
    },
    "minLevel": 20,
    "clash": {
      "timezone": "Europe/Istanbul",
      "starts": ["14:00", "22:00"],
      "signupMinutes": 10,
      "minutes": 20,
      "killsToWin": 30,
      "minPerSide": 1,
      "maxPerSide": 6,
      "crystal": {
        "x": 0,
        "z": 0
      },
      "endAfterWinMs": 60000,
      "exitsPerDay": 1,
      "penaltyHours": 24,
      "returnTo": "dev_field",
      "brackets": [
        {
          "minLevel": 20,
          "maxLevel": 39,
          "crystal": "clash_crystal",
          "win": "sapphire_coffer",
          "lose": "jade_coffer"
        },
        {
          "minLevel": 40,
          "maxLevel": 60,
          "crystal": "greater_clash_crystal",
          "win": "greater_sapphire_coffer",
          "lose": "greater_jade_coffer"
        }
      ],
      "gmsMayJoin": true
    },
    "portals": [
      {
        "x": 0,
        "z": -72,
        "rot": 0,
        "label": "Way back",
        "only": "dev_field"
      },
      {
        "x": 0,
        "z": 72,
        "rot": 180,
        "label": "Way back",
        "only": "dev_field"
      }
    ]
  }
]
